import { Component, OnInit, Input, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
// import { NgForm } from '@angular/forms';

import { ModalService } from './modal.service';
import { GlobalService } from '../../services/global.service';
import { SnackBarService } from '../snackbar/snackbar.service';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Advisor } from '../../models/advisor';
import { Client } from '../../models/client';
import { Organization } from '../../models/organization';

import Utils from '../utility';
import { RequestOptions } from '@angular/http';

import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingService } from '../../shared/loading/loading.service';

// import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions, UploadStatus } from 'ngx-uploader';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    '(document:click)': 'onClick($event)',
  }
})

export class ModalComponent implements OnInit {

  public dateofBirth;
  public currentYear;
  public yob;
  public endYear1;
  public endYear2;
  public endOfPIAStartYear;
  public endOfPIAEndYear;
  public age;
  public showAge;
  public min;
  public maxAge;
  public minAge;
  public showAgeSpouse;
  public spouseAgeOver;
  public spouseAgeOverEighty;

  public spouseDateofBirth;			
  public spouseYob;
  public spouseEndOfPIAStartYear;
  public spouseEndYear1;
  public spouseEndYear2;
  public spouseEndOfPIAEndYear;
  public spouseShowAge;
  public spouseMinAge;
  public spouseMaxAge;
  public SpouseMin;
  public ageOverEighty;
  ageOver: boolean; 

  public pensionMinYear;
  public pensionMaxYear;
  public spousePensionMinYear;
  public spousePensionMaxYear;
  public endOfPensionYear;
  public spouseEndOfPensionYear;

  public clientPreviousSpouseMaxAge;
  public clientPreviousSpouseMinAge;

  public spousePreviousSpouseMaxAge;
  public spousePreviousSpouseMinAge;

  public fullYear;
  public convertSpouseYear;
  public SpouseFullYear;

  public ageEighteen;
  public eighteenYearsAgo;
  private today = new Date();

  public firstPage;
  public secondPage;
  public thirdPage;
  public forthPage;
  public fifthPage;
  public sixthPage;
  public seventhPage;

  public isRiskTolerance: boolean = false;

  public aggrementSrc: string;

  isChecked: boolean;
  isClientEmailChecked: boolean;
  isFinalAgreementChecked: boolean;

  riskToleranceQuestionnaire: FormGroup;
  riskToleranceNames: FormGroup;
  riskToleranceAggrement: FormGroup;
  riskToleranceMail: FormGroup;

  riskTolernaceSection: string = 'riskToleranceQuestionnaire';
  dateTimeNow: string;
  clientFirstName: string;
  clientLastName: string;
  spouseFirstName: string;
  spouseLastName: string;
  isNotCandidate: boolean;
  lastClickedSignedAgreement: string;
  reportObj;
  AssetManagementAdv2DocUrl;
  AssetManagementAgreement;
  OrgRIAFee;
  advisoryFee: number;
  AssetManagementAgreementChangedDate;

  futureTotalCost: number;
  portfolioRecommendationObject: any;






  @ViewChild('container') container: ElementRef;
  @ViewChild('scrollEl') scrollEl: ElementRef;
  private selDate: IMyDate = { year: 0, month: 0, day: 0 };
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    editableDateField: true,
    showTodayBtn: false,
    /*   disableUntil: { year: 1930, month: 1, day: 1 },
      disableSince: { year: 2000, month: 1, day: 1 } */
    disableUntil: { year: 1930, month: 1, day: 1 },
    disableSince: { year: this.today.getFullYear() - 18, month: this.today.getMonth() + 1 , day: this.today.getDate() + 1 }

  };

  public myDatePickerOptionsAnn: IMyDpOptions = {
    // other options...
    dateFormat: "mm/dd/yyyy",
    editableDateField: true,
    showTodayBtn: false,
    disableUntil: { year: 1948, month: this.today.getMonth() + 1 , day: this.today.getDate() + 1 },
    disableSince: { year: this.today.getFullYear(), month: this.today.getMonth() + 1 , day: this.today.getDate() + 1 }
  };

  // Initialized to specific date (09.10.2018).
  public defaultDateModel: any = { date: { year: 1960, month: 1, day: 1 } };

  public currentAddEditClientScreen: Number = 0;
  public previousAddEditClientScreen: Number = 0;

  public selectedDocFilePath: string;
  public selectedDocEvent: any;
  public selectedDocCategory: string;

  public currentRiskToleranceScreen: Number = 1;

  public isValidAdvisor = false;


  public selectedDocument: any = {
    title: '',
    description: '',
    category: '',
  }

  public healthInformationInfo: string = "These inputs will impact life expectancy projections (see below), which is featured within every illustration and report, as well as annual out-of-pocket health care costs.";

  public validFormInputs: any = [
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
    { isValid: false },
  ]

  public advisorModal: any = {
    generalInformation: {
      firstName: '',
      lastName: '',
      title:'',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      id: ''
    }
  }
  public clientModal: any = {
    generalInformation: {
      generalInformation: {
        firstName: '',
        lastName: '',
        gender: '',
        dob: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        email: '',
      },
      anticipatedRetirementInformation: {
        retirementAge: '',
        retirementState: '',
      },
    },
    financialInformation: {
      PIAYears: {
        IncludePIA: false,
        StartYear: '',
        EndYear: '',
        Years: []
      },
      hasPension: false,
    },
    maritalStatus: {
      firstName: '',
      lastName: '',
    },
    healthConditions: {},
    currentMaritalStatus: {},
    maritalHistory: {
      previouslyMarried: {},

    },
    spouses: [
      { firstName: '', lastName: '' }
    ],
    dependentChildren: {},
  }

  prepSpouses(count) {
    this.clientModal.maritalHistory.spouses = new Array(count);
  }

  handlePrint(e) {
    window.print();
  }

  prepSpousesSpouse(count) {
    this.clientModelV2.maritalHistory.spousesSpouse = [];

    for (var i = 0; i < count; i++) {
      if (this.clientModelV2.maritalHistory.spousesSpouse[i]) {
        this.clientModelV2.maritalHistory.spousesSpouse.push(this.clientModelV2.maritalHistory.spousesSpouse[i]);
      } else {
        this.clientModelV2.maritalHistory.spousesSpouse.push({
          tenyears: false,
          alive: true,
        });
      }
    }

  }

  prepChildren(count) {
    this.clientModelV2.dependentChildren.children = [];

    for (var i = 0; i < count; i++) {
      this.clientModelV2.dependentChildren.children.push({
        DependentChildAge: 0,
      })
    }
  }

  dissabledConinueBtn: boolean = false;
  updateAddEditClientScreen(page) {
    
    if (page == 1 && this.ID == 0) {
      this.minAge = this.min = Math.min(this.clientModelV2.healthInformation.lifeExpectancy, this.showAge);  
      this.maxAge = 100 - this.minAge + 1; 
    }
    this.dissabledConinueBtn = false;
    if (page == -1) {
      this.isSelectingAdvisor = false;

      this.advisors.forEach((a) => {
        if (a.c.ID == this.selectedAdvisor) {
          this.selectedAdvisor = a;
        }
      });


      this.validateFields(page);
      return;
    }

    if (page !== this.currentAddEditClientScreen) {
      this.previousAddEditClientScreen = this.currentAddEditClientScreen;
      this.currentAddEditClientScreen = page;
      // console.log('validateFields 01');
      this.validateFields(page);
    }

    if (page == this.fifthPage && !this.featRiskTolerance) {
      // console.log('validateFields 02');
      this.validateFields(page);
      // this.validateFields(page);
      
      this.dissabledConinueBtn = true;
    }
    if (page == this.sixthPage && this.featRiskTolerance) {
      // console.log('validateFields 03');
      this.validateFields(page);
      
      this.dissabledConinueBtn = true;
    } 

  }

  uploadFileChanged(e) {
    this.selectedDocEvent = e;
    this.selectedDocFilePath = e.target.files[0].name;
  }

  test(e) {
  }


  validateAge() {
    var eighteenYearsAgo = new Date();
    this.eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    this.ageEighteen = eighteenYearsAgo.getFullYear();
  }


  validateDefaultDate: boolean;
  validateDefaultDate2: boolean;

  validateDefaultDate3: boolean;

 


  validateFields(page) {
    var isValid = true;
    if (page === -1) {
      if (this.clientModelV2.generalInformation.dob === undefined || this.clientModelV2.generalInformation.dob === '' || this.clientModelV2.generalInformation.dob >= 80) {
        //this.validateDefaultDate = true;
        //this.clientModelV2.generalInformation.dob = this.defaultDOB;
        //this.clientModelV2.generalInformation.dobStr = this.defaultDOBStr;//this.clientModelV2.generalInformation.dob;
      } else {
        //isValid = isValid && this.clientModelV2.generalInformation.dobStr.length > 0;
       this.validateDefaultDate = this.validateDate(this.clientModelV2.generalInformation.dobStr, true);  
      }

    }
    if (page === this.firstPage) {
      // console.log('button disable 08');
        this.clientModelV2.generalInformation.dobStr;   
      this.clientModelV2.maritalStatus.dobStr; 

        if (this.clientModelV2.generalInformation.dobStr) {
          const convertAge = new Date(this.clientModelV2.generalInformation.dobStr);
          const timeDiff = Math.abs(Date.now() - convertAge.getTime());
          this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);         
         }  


      if (this.clientModelV2.maritalStatus.dobStr) {
        const spouseConvertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
        const SpouseTimeDiff = Math.abs(Date.now() - spouseConvertAge.getTime());
        this.showAgeSpouse = Math.floor((SpouseTimeDiff / (1000 * 3600 * 24))/365); 
       }  

      if (this.clientModelV2.generalInformation.dobStr) {
        // console.log('button disable 09');
        const convertYear = new Date(this.clientModelV2.generalInformation.dobStr); 
        this.currentYear = new Date().getFullYear();
        this.fullYear = convertYear.getFullYear();        
        this.yob = this.fullYear + 14;
       
       this.endOfPIAStartYear = this.currentYear - this.yob + 1;      
       this.endYear1 = this.fullYear + 30;
       this.endYear2 = this.fullYear + 80;               
       this.endOfPIAEndYear = this.endYear2 - this.endYear1 + 1; 
     
       this.pensionMinYear = this.fullYear + 50;
       this.pensionMaxYear = this.fullYear + 75;
       this.endOfPensionYear =  this.pensionMaxYear - this.pensionMinYear + 1;    
      }

      if (this.clientModelV2.maritalStatus.dobStr) {
      const convertSpouseYear = new Date(this.clientModelV2.maritalStatus.dobStr);      
      this.currentYear = new Date().getFullYear();
      this.SpouseFullYear = convertSpouseYear.getFullYear();
      this.spouseYob = this.SpouseFullYear + 14;

      this.spouseEndOfPIAStartYear = this.currentYear - this.spouseYob + 1;      
      this.spouseEndYear1 = this.SpouseFullYear + 30;
      this.spouseEndYear2 = this.SpouseFullYear + 80;               
      this.spouseEndOfPIAEndYear = this.spouseEndYear2 - this.spouseEndYear1 + 1; 

      this.spousePensionMinYear = this.SpouseFullYear + 50;
      this.spousePensionMaxYear = this.SpouseFullYear + 75;
      this.spouseEndOfPensionYear =  this.spousePensionMaxYear - this.spousePensionMinYear + 1;      
      }

      isValid = isValid && this.clientModelV2.generalInformation.firstName.length > 0;
      isValid = isValid && this.clientModelV2.generalInformation.lastName.length > 0;
      isValid = isValid && (this.clientModelV2.generalInformation.gender == 1 || this.clientModelV2.generalInformation.gender == 2);
      // console.log('button disable 10');
      // console.log(this.clientModelV2.generalInformation.firstName.length);
      // console.log(this.clientModelV2.generalInformation.lastName.length);
      // console.log(this.clientModelV2.generalInformation.gender);
      // console.log('this.clientModelV2.generalInformation.dob');
      // console.log(this.clientModelV2.generalInformation.dob);
      //isValid = isValid && this.clientModelV2.generalInformation.dobStr.length > 0;      
      if (this.clientModelV2.generalInformation.dob === undefined || this.clientModelV2.generalInformation.dob === '' || this.clientModelV2.generalInformation.dob === this.defaultDOB || this.clientModelV2.generalInformation.dob >= 80) {
        //this.validateDefaultDate = true;
        //this.clientModelV2.generalInformation.dob = this.defaultDOB;
        //this.clientModelV2.generalInformation.dobStr = this.defaultDOBStr;//this.clientModelV2.generalInformation.dob;
        // console.log('if check this.clientModelV2.generalInformation.dob');
        isValid = false;

      } 
      else {  
        isValid = isValid && this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.dobStr.length > 0;
        this.validateDefaultDate = this.validateDate(this.clientModelV2.generalInformation.dobStr, true);
        
      }

      if (page === 0) {
        // console.log('button disable 11');
        // console.log(isValid);
        isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;
        // console.log('button disable 12');
        // console.log(isValid);
        if (isValid) {
          if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
            // console.log('button disable 13');
            isValid = true;
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {


            if (this.clientModelV2.maritalStatus.dob === undefined) {
              this.validateDefaultDate = true;

            } else {
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
            }

            isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
            isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
            //isValid = isValid && this.clientModelV2.maritalStatus.anniversaryStr && this.clientModelV2.maritalStatus.anniversaryStr.length > 0;

            let clientAge = this.calculateAge(this.clientModelV2.generalInformation.dobStr);
            let spouseAge = this.calculateAge(this.clientModelV2.maritalStatus.dobStr);
            if (this.clientModelV2.maritalStatus.anniversaryStr) {
              let yearsMarried = this.calculateAge(this.clientModelV2.maritalStatus.anniversaryStr);
              isValid = isValid && (clientAge - yearsMarried >= 18 && spouseAge - yearsMarried >= 18);
            }


            isValid = isValid && this.clientModelV2.maritalStatus.dobStr.length > 0;
            isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);

            isValid = isValid && this.clientModelV2.maritalStatus.retirementAge > 0;
            isValid = isValid && this.clientModelV2.maritalStatus.retirementState != '' && this.clientModelV2.maritalStatus.retirementState.length > 1;

          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Divorced') {
            if (this.clientModelV2.maritalStatus.dob === undefined) {

            } else {
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
            }

            if (this.clientModelV2.maritalHistory.alive) {
              isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
              isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);

              if (this.clientModelV2.maritalHistory.tenyears) {
                isValid = isValid && this.clientModelV2.maritalStatus.retirementAge > 0;
                isValid = isValid && this.clientModelV2.maritalStatus.retirementState != '' && this.clientModelV2.maritalStatus.retirementState.length > 1;
              }
            }

            isValid = isValid && (this.clientModelV2.maritalHistory.alive == true || this.clientModelV2.maritalHistory.alive == false);


            if (this.clientModelV2.maritalHistory.alive)
              isValid = isValid && (this.clientModelV2.maritalHistory.tenyears == true || this.clientModelV2.maritalHistory.tenyears == false);

            if (!this.clientModelV2.maritalHistory.alive) {
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;

            }

          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Widowed' || this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Widow') {
            isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
            isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
          }
        }
      }
      // console.log('button disable 14');
      // console.log(isValid);
      isValid = isValid && this.clientModelV2.generalInformation.retirementAge >= 30;
      // console.log('button disable 15');
      // console.log(isValid);
      // console.log(this.clientModelV2.generalInformation.retirementAge);
      isValid = isValid && this.clientModelV2.generalInformation.retirementState.length > 0;
      // console.log('button disable 15');
      // console.log(isValid);
      isValid = isValid && this.validateString(this.clientModelV2.generalInformation.firstName, true);
      // console.log('button disable 16');
      // console.log(isValid);
      isValid = isValid && this.validateString(this.clientModelV2.generalInformation.lastName, true);
      // console.log('button disable 17');
      // console.log(isValid);
      isValid = isValid && this.showAge < 80
      // console.log('button disable 18');
      // console.log(isValid);
      
      if (this.showAge >= 80) {   
        this.ageOver = true;
        this.ageOverEighty = "Client age cannot be greater than 80.";
      } else {
        this.ageOver = false;
      }
      if (this.clientModelV2.maritalStatus && (this.clientModelV2.maritalStatus.maritalStatus != 'Single' && this.clientModelV2.maritalStatus.maritalStatus != 'Widowed')) {
        
        isValid = isValid && this.validateString(this.clientModelV2.maritalStatus.firstName, true);
        isValid = isValid && this.validateString(this.clientModelV2.maritalStatus.lastName, true);
        

        isValid = isValid && this.showAgeSpouse < 80
        if (this.showAgeSpouse >= 80) {
          this.spouseAgeOver = true;
          this.spouseAgeOverEighty = "Spouse age cannot be greater than 80.";
        } else {
          this.spouseAgeOver = false;
        }
      }
    } 
    
    //PAGE 1
    else if (page === this.secondPage) {
      isValid = isValid && this.clientModelV2.financialInformation.currentIncome != "" && this.clientModelV2.financialInformation.currentIncome.length > 1;
      isValid = isValid && this.clientModelV2.financialInformation.irr != "" && this.clientModelV2.financialInformation.irr.length > 0;
      isValid = isValid && this.clientModelV2.financialInformation.pia != "" && this.clientModelV2.financialInformation.pia.length > 1;
      
      isValid = isValid && this.clientModelV2.generalInformation.dob;
      
      if (this.clientModelV2.financialInformation.PIAYears.IncludePIA) {
        isValid = isValid && Number(this.clientModelV2.financialInformation.PIAYears.StartYear) > 1900;
        isValid = isValid && Number(this.clientModelV2.financialInformation.PIAYears.EndYear) > 1900;
        isValid = isValid && this.clientModelV2.financialInformation.PIAYears.Years.length > 0;
      }

      if (this.clientModelV2.financialInformation.hasPension) {
        isValid = isValid && this.clientModelV2.financialInformation.pensionAmount.length > 1;
        isValid = isValid && this.clientModelV2.financialInformation.pensionStartMonth > 0;
        isValid = isValid && this.clientModelV2.financialInformation.pensionStartYear > 0;
        isValid = isValid && this.clientModelV2.financialInformation.pensionSubEarnings > 0;
      }


      if (page === this.firstPage) {

        isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;
      
        if (isValid) {
          if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
            isValid = true;
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      
            if (this.clientModelV2.maritalStatus.dob === undefined) {
              this.validateDefaultDate = true;
      
            } else {
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              this.validateDefaultDate2 = isValid && this.validateDate(this.clientModelV2.maritalStatus.dobStr, true);
            }
            
            isValid = isValid && this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.lifeExpectancy && this.clientModelV2.maritalStatus.lifeExpectancy > 0;
            isValid = isValid && this.clientModelV2.maritalStatus.currentIncome != "" && this.clientModelV2.maritalStatus.currentIncome.length > 1;
            isValid = isValid && this.clientModelV2.maritalStatus.pia.length > 1;
      
            if (this.clientModelV2.maritalStatus.PIAYears.includePIA === true) {
              isValid = isValid && Number(this.clientModelV2.maritalStatus.PIAYears.startYear) > 1900;
              isValid = isValid && Number(this.clientModelV2.maritalStatus.PIAYears.endYear) > 1900;
              isValid = isValid && this.clientModelV2.maritalStatus.PIAYears.years.length > 0;
            }
      
            if (this.clientModelV2.maritalStatus.includePension === true) {
              isValid = isValid && this.clientModelV2.maritalStatus.pensionAmount && this.clientModelV2.maritalStatus.pensionAmount.length > 1;
              isValid = isValid && this.clientModelV2.maritalStatus.pensionMonths > 0;
              isValid = isValid && this.clientModelV2.maritalStatus.pensionYears > 0;
              isValid = isValid && this.clientModelV2.maritalStatus.subEarnings > 0;
            }
                     
      
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Divorced') {

            if (this.clientModelV2.maritalHistory.alive) {
              isValid = isValid && this.clientModelV2.maritalStatus.firstName != "";
              isValid = isValid && this.clientModelV2.maritalStatus.lastName != "";
              isValid = isValid && this.clientModelV2.maritalStatus.dobStr && this.clientModelV2.maritalStatus.dobStr.length > 0;
              isValid = isValid && (this.clientModelV2.maritalStatus.gender == 1 || this.clientModelV2.maritalStatus.gender == 2);
      
              if (this.clientModelV2.maritalHistory.tenyears) {
                isValid = isValid && this.clientModelV2.maritalStatus.pia != "";
              }
            }

            isValid = isValid && (this.clientModelV2.maritalHistory.alive == true || this.clientModelV2.maritalHistory.alive == false);
      
            if (this.clientModelV2.maritalHistory.alive)
              isValid = isValid && (this.clientModelV2.maritalHistory.tenyears == true || this.clientModelV2.maritalHistory.tenyears == false);
      
            if (!this.clientModelV2.maritalHistory.alive) {
              isValid = isValid && this.clientModelV2.maritalStatus.pia != "";
            }
      
          } else if (this.clientModelV2.maritalStatus && this.clientModelV2.maritalStatus.maritalStatus === 'Widow') {
            isValid = isValid && this.clientModelV2.maritalStatus.pia != "";
          }
        }
      
      }


      // new logic
      isValid = isValid && this.validateCurrency(this.getNumber(this.clientModelV2.financialInformation.currentIncome), 0, 5000001, true);
      isValid = isValid && this.validateCurrency(this.getNumber(this.clientModelV2.financialInformation.pia), 0, 4251, true);
      isValid = isValid && this.validatePercent(this.getNumber(this.clientModelV2.financialInformation.irr), 10, 201, true);
      if (this.clientModelV2.maritalStatus && (this.clientModelV2.maritalStatus.maritalStatus === 'Married')) {
        isValid = isValid && this.validateCurrency(this.getNumber(this.clientModelV2.maritalStatus.currentIncome), 0, 5000001, true);
      }
      if (this.clientModelV2.maritalStatus && (this.clientModelV2.maritalStatus.maritalStatus != 'Single')) {
        isValid = isValid && this.validateCurrency(this.getNumber(this.clientModelV2.maritalStatus.pia), 0, 4251, true);
        if (this.clientModelV2.maritalStatus && (this.clientModelV2.maritalStatus.maritalStatus != 'Widowed')) {
          // isValid = isValid && this.validateCurrency(this.getNumber(this.clientModelV2.maritalStatus.currentIncome), 0, 5000001, true);
        }
      }


    } 
    
    //PAGE 2
    /* else if (page === this.thirdPage) {
      isValid = isValid && this.clientModelV2.riskTolerance.financialObjective && this.clientModelV2.riskTolerance.levelOfInvestment && this.clientModelV2.riskTolerance.lengthOfInvestment > 0;
    } */

    // PAGE 3
    else if (page === this.thirdPage) {
      isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;
    } 
        
    //PAGE 3 REFACTORED//
    else if (page === this.forthPage) {
      isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;
      if (isValid) {
        if (!this.clientModelV2.maritalHistory.previouslyMarried && !this.clientModelV2.maritalHistory.spousePreviouslyMarried) {
          isValid = true;
        } else {
          if (this.clientModelV2.maritalHistory.previouslyMarried) {
            isValid = isValid && this.clientModelV2.maritalHistory.previousSpouseCount > 0;

            for (var spouse in this.clientModelV2.spouses) {
              if (Number(spouse) != 0) {
                isValid = isValid && this.clientModelV2.spouses[spouse].firstName.length > 0;
                isValid = isValid && this.clientModelV2.spouses[spouse].lastName.length > 0;
                isValid = isValid && this.clientModelV2.spouses[spouse].pia.length >= 0;

                if (this.clientModelV2.spouses[spouse].maritalStatus === 'Divorced') {
                  isValid = isValid && (this.clientModelV2.spouses[spouse].gender == 1 || isValid && this.clientModelV2.spouses[spouse].gender == 2);
                  isValid = isValid && this.clientModelV2.spouses[spouse].dobStr && this.clientModelV2.spouses[spouse].dobStr.length > 0;
                  isValid = isValid && (typeof this.clientModelV2.spouses[spouse].alive != 'undefined');

                  if (this.clientModelV2.spouses[spouse].alive) {
                    isValid = isValid && (typeof this.clientModelV2.spouses[spouse].tenyears != 'undefined');
                  }
                }
              }
            }
          }

          if (this.clientModelV2.maritalHistory.spousePreviouslyMarried) {
            isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouseCount > 0;
            for (var spouse in this.clientModelV2.maritalHistory.spousesSpouse) {
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].firstName.length > 0;
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].lastName.length > 0;
              isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].pia.length > 0;
              if (this.clientModelV2.maritalHistory.spousesSpouse[spouse].maritalStatus === 'Divorced') {
                isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].gender == 1 || isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].gender == 2;
                isValid = isValid && this.clientModelV2.maritalHistory.spousesSpouse[spouse].dobStr.length > 0;
              }
            }
          }
        }
      }
    }
    
    else if (page === this.fifthPage) {
      isValid = isValid && this.clientModelV2.healthInformation && this.clientModelV2.healthInformation.lifeExpectancy && this.clientModelV2.healthInformation.lifeExpectancy > 0;

      if (isValid) {
        if (this.clientModelV2.dependentChildren.hasKids) {
          for (var child in this.clientModelV2.dependentChildren.children) {
            isValid = isValid && this.clientModelV2.dependentChildren.children[child].DependentChildAge > 0;
          }
        } else {
          isValid = true;
        }
      }
    }
    else if (page === this.sixthPage && this.featRiskTolerance ) {
      let re = /\%/gi;
      let annualProgramFee = this.advisorModal.generalInformation.annualProgramFee.replace(re, "");
      let isAnnularProgramFee = (annualProgramFee != 'null' && annualProgramFee) ? true : false;
      isValid = isValid && isAnnularProgramFee;
      if (annualProgramFee != 'null' && annualProgramFee) {
        isValid = isValid && this.validatePercentDecimal(this.advisorModal.generalInformation.annualProgramFee, 0.1, 9.99, true);
      }

    }


    if (page >= this.firstPage) {
      this.validFormInputs[page].isValid = isValid;
    }
     
  }

  ValidateInputScreen(page) {
    if (page === 0) {

    }
  }

  mapToSpouses(model) {
  }

  updateSpouses(model) {
    if (model.spouses.length - 1 > this.clientModelV2.maritalHistory.previousSpouseCount) {
      this.clientModelV2.spouses.splice(Number(this.clientModelV2.maritalHistory.previousSpouseCount) + 1, (model.spouses.length - (Number(this.clientModelV2.maritalHistory.previousSpouseCount) + 1)));
    }
    if (model.maritalStatus.maritalStatus == 'Single' || model.maritalStatus.maritalStatus == 'Married' || model.maritalStatus.maritalStatus == 'Divorced' || model.maritalStatus.maritalStatus == 'Widow') {

    }

    if (model.spouses.length - 1 < this.clientModelV2.maritalHistory.previousSpouseCount) {
      for (var i = 0; i <= this.clientModelV2.maritalHistory.previousSpouseCount; i++) {
        if (model.spouses[i] && model.spouses[i].maritalStatus) {

        } else {
          this.clientModelV2.spouses.push({
            maritalStatus: '',
            firstName: '',
            lastName: '',
            pia: 0,
            gender: 0,
            dobStr: '',
          });
        }
      }
    }
  }


  public allStates: any[] = Utils.allStates;
  public allStates2: any[] = Utils.allStates;

  public months: any[] = Utils.months;

  public categories: any = {};

  public error: string;

  public modalName: string;
  private ID: number; // ID of whatever entity we need to get data for

  public advisorOrganization: string = "This input field will allow you to create a client on behalf of, and assign it to the selected organization. PDF reports generated will show information and brand logos for the selected organization.";
  public assignAdvisor: string = "This input field will allow you to create a client on behalf of, and assign it to the selected organization. PDF reports generated will show information and brand logos for the selected advisor.";
  public currentAgeMessage: string = "Your date of birth allows us to project inflation and other factors that will occur over time, leading up to your retirement.";
  public retirementAgeMessage: string = "This is the year at which your income switches to an amount affected by your Income Replacement Ratio. This is not your Social Security Full Retirement Age or claim age, but for income calculation purposes on the Medicare Means Testing tool, this is the age when income switches from the amount earned as a worker to an amount earned in retirement.";
  public currentIncomeMessage: string = "This amount will be inflated out to retirement age and then multiplied by the income replacement ratio to determine projected retirement income. This should include income off of which the client currently maintains their standard of living, like compensation, bonuses, investment income, or rental income, for example.";
  public maritalStatusMessage: string = "This affects your Social Security claiming options, and for those currently married, all reports with run for both you and your spouse.";
  //public retirementStateMessage: string = "Retirement health care costs vary based on state of residence. Your retirement state may be different than your state of residence";
  public retirementStateMessage: string = "Retirement health care costs vary based on state of residence. Your retirement state may be different than your state of residence. Medicare Part D premiums, supplemental insurance, and out-of-pocket costs may vary depending on state.";
  public currentIRRMessage: string = "This is the percentage of pre-retirement income that the entire household (spouse included, if applicable) will need in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
  public nationalAvgMessage: string = "This should be used if the client is not sure where they might retire, even if a retirement state is selected.";
  public highBloodPressureMessage: string = 'Clients diagnosed with high blood pressure by a doctor should answer yes to this question. High blood pressure indicates high pressure (tension) in the arteries and is typically a blood pressure of 140/90 or higher. Normal blood pressure is below 120/80. Blood pressure between 120/80 and 139/89 is called "pre-hypertension".';
  public highCholesterolMessage: string = "Clients diagnosed with high cholesterol by a doctor should answer yes to this question. High levels of cholesterol in the blood is not a disease but a condition that lead to other diseases, most notably cardiovascular disease. A doctor typically considers high cholesterol a measurement greater than 200 mg/dL, LDL cholesterol levels greater than 130 mg/dL and HDL cholesterol levels less than 60 mg/dL.";
  public type2DiabetesMessage: string = "Clients diagnosed with type 2 diabetes (managed or unmanaged) by a doctor should answer yes to this question. Type 2 diabetes is a chronic condition that affects the way someone’s body metabolizes sugar (glucose); a condition characterized by high blood glucose levels caused by either a lack of insulin or the body's inability to use insulin efficiently.";
  public cardiovascularDiseaseMessage: string = "Clients diagnosed as having cardiovascular disease by a doctor should answer yes to this question. Cardiovascular disease is a disease affecting the heart or blood vessels. Some conditions that fall under the umbrella of cardiovascular disease are aneurysm, angina, arrhythmia, cardiomyopathy, congenital cardiovascular defects, congenital heart disease, congestive heart failure, heart attack, diseases of pulmonary circulation, endocarditis, rheumatic fever, stroke, heart valve disease, diseases of the circulatory system.";
  public tobaccoMessage: string = "Clients having used tobacco in any form (cigarettes, cigars, pipes etc..) on a consistent basis within the last 5 years should answer yes to this question.";
  public cancerMessage: string = "Clients should answer yes to this question if they have ever been diagnosed with any type of cancer, including breast cancer, skin cancer, lung cancer, colon cancer, prostate cancer, lymphoma, or other type of cancer.";

  public piaMessage: string = "If you don’t know your client’s PIA and want to calculate it manually, check this box and follow the instructions that appear.";
  public pensionMessage: string = "Individuals who are receiving (or are going to receive) a pension during their retirement based on working years during which they did not pay into Social Security should check this box.";
  public pensionBaseMessage: string = "The government applies provisions to Social Security regulations which may decrease or eliminate a benefit or spousal benefit given to someone who is receiving a pension.";
  public pensionStartMessage: string = "Please identify when the client will start receiving a pension. Social Security does not make deductions unless the client is currently receiving a pension. A start year is needed so as not to impose deductions in our projections that do not actually apply at that time.";
  public pensionStartMonthMessage: string = "Please identify when the client will start receiving a pension. Social Security does not make deductions unless the client is currently receiving a pension. A start month is needed so as not to impose deductions in our projections that do not actually apply at that time.";
  public pensionSubMessage: string = "Social Security measures Substantial Earnings Years by the amount of money an individual earns in a calendar year on income that is taxed by Social Security. This metric is needed to calculate deductions made to the client’s Social Security benefit by the Windfall Elimination Provision. A chart with these measures for each year can be found at http://www.ssa.gov/pubs/EN-05-10045.pdf.";

  public lifeExpectancyMessage: string = "Appropriately assessing your client’s health and longevity is a top consideration for each tool on this platform. Primary drivers of life expectancy include gender, current age, and health conditions/lifestyle. The amount defaulted in the input field is based on those variables, but you may override this result if you desire.";
  public primaryInsuranceAmountMessage: string = "Primary Insurance Amount is the monthly benefit the client will receive from Social Security at Full Retirement Age based on their earnings record. This amount is needed to project benefits throughout the client’s lifetime. This amount can be found at <a target='blank' href='https://secure.ssa.gov/RIL/SiView.do'>https://secure.ssa.gov/RIL/SiView.do</a>"
  public nationalAverageMessage: string = `Selecting "Yes" will show all projections based on national average instead of featuring the data specific to the chosen retirement state above. This selection may be made is the client is unsure of where they will spend their retirement years or if you are running a case study and looking for generic data.`;
  public previouslyMarriedMessage: string = "Aside from a current marriage, how many times have you been legally married?";

  public annualProgramFeeMessage: string = "Enter the percentage between 0.10 to 9.99"

  private advisor: Advisor;
  public client: any = {};
  public clientData = false;
  private organization: Organization;

  private modalData: any;

  public dobYear;

  private createClientModel: any = {
    client: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
    },
    clientProfile: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
      // LifeExpectancy: 88,
      clientSpouses: [],
      clientChildren: [],
      PIAYears: {
        IncludePIA: false,
      }
    },
  };

  private editClientModel: any = {
    loaded: false,
    client: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
    },
    clientProfile: {
      HCHBP: false,
      HCHC: false,
      HCT2D: false,
      HCCD: false,
      HCC: false,
      HCT: false,
      clientSpouses: [],
      clientChildren: [],
      PIAYears: {
        IncludePIA: false,
      }
    },
  };

  public modalSubscription;

  public clientDOB: IMyDate = {
    year: 1970,
    month: 1,
    day: 1,
  };

  public annDate: IMyDate = {
    year: 1970,
    month: 1,
    day: 1,
  };

  public testDate: IMyDate = {
    year: 0,
    month: 0,
    day: 0,
  }

  public clientModelV2: any = {
    generalInformation: {
      firstName: '',
      lastName: '',
      gender: '',
      dob: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      retirementAge: '',
      retirementState: '',
    },
    financialInformation: {
      currentIncome: '',
      irr: '',
      pia: '',
      PIAYears: {},
      pensionAmount: 0,
      pensionStartMonth: '',
      pensionStartYear: '',
      pensionSubEarnings: '',
      hasPension: '',
    },

    riskTolerance: {
      financialObjective:'',
      levelOfInvestment:'',
      lengthOfInvestment:'',
      toleranceOfRisk:'',
      isRedeemAccount:'',
      hasSignedAgreement: '',
      hasSignedUpForManagedAccount: ''
    },
    healthInformation: {
      HCC: false,
      HCCD: false,
      HCHBP: false,
      HCHC: false,
      HCT: false,
      HCT2D: false,
      lifeExpectancy: '',
    },
    maritalStatus: {
      maritalStatus: 'Single',
      firstName: '',
      lastName: '',
      gender: '',
      lifeExpectancy: '',
      currentIncome: '',
      pia: '',
      PIAYears: {
        includePIA: '',
        startYear: '',
        endYear: '',
        years: [],
      },
    },
    spouses: [
      { maritalStatus: 'Single' }
    ],
    maritalHistory: {
      previousSpouseCount: 0,
      previouslyMarried: false,
    },
    dependentChildren: {
      children: [],
      hasKids: false,
    }
  }

  d: Date = new Date();
  defaultDOB = { date: { year: this.d.getFullYear() - 55, month: this.d.getMonth() + 1, day: this.d.getDate() } };
  defaultDOBStr = ((this.d.getMonth() + 1 <= 9) ? "0" + (this.d.getMonth() + 1) : (this.d.getMonth() + 1)) + "/" + ((this.d.getDate() <= 9) ? "0" + this.d.getDate() : this.d.getDate()) + "/" + (this.d.getFullYear() - 55);
 
  isHCIllustration: boolean = false;

  estimatedCosts: number;
  ssDeductions: number;
  remainingUnfunded: number;
  phase1Portfolio: string;
  phase2Portfolio: string;
  isRetired: boolean = false;
  rorPhaseOneRate: number;
  rorPhaseTwoRate: number;
  rorPhaseOneYear: string;
  equitiesLargeCap: number;
  equitiesMidCap: number;
  equitiesSmallCap: number;
  equitiesInternational: number;
  equitiesReturn: number;
  fixedGovBonds: number;
  fixedCorpBonds: number;
  fixedReturn: number;
  cashMoneyMarket: number;
  cashMoneyMarketReturn: number;
  displayCancelBtn: boolean = false;

  constructor(private modalService: ModalService, private globalService: GlobalService, private snackBarService: SnackBarService, private loadingService: LoadingService, private router: Router, private sanitizer: DomSanitizer, private fb: FormBuilder) {
    this.modalSubscription = modalService.modal$.subscribe(modal => {
      this.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));
      console.log('this.featRiskTolerance', this.featRiskTolerance);
      this.isHCIllustration = (modal.data.Page == 'HC');
      if (modal.modalName.indexOf('Closed') == -1) {
        this.modalName = modal.modalName;
        this.modalData = modal.data;
         // console.log('this.modalData');
         // console.log(this.modalData);
        this.ID = modal.data.ID;

        this.currentAddEditClientScreen = 0;

        //hide for PacLife and OA
        this.displayCancelBtn = (Number(localStorage.getItem('orgID')) === 761 || Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? false : true;

        this.selectedAdvisor = null;
        this.selectedOrganization = null;
        this.organizations = [];
        this.selectedAdvisors = [];

        this.clientModelV2 = {
          generalInformation: {
            firstName: '',
            lastName: '',
            gender: '',
            dob: '',//this.defaultDOB, //avg user is 55yo
            address: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            email: '',
            useNationalAverage: false,
            retirementAge: '',
            retirementState: '',
          },
          financialInformation: {
            currentIncome: '',
            irr: '',
            pia: '',
            PIAYears: {},
            pensionAmount: 0,
            pensionStartMonth: '',
            pensionStartYear: '',
            pensionSubEarnings: '',
            hasPension: '',
          },

          riskTolerance: {
            financialObjective:'',
            levelOfInvestment:'',
            lengthOfInvestment:'',
            toleranceOfRisk:'1',
            isRedeemAccount:'1',
          },

          healthInformation: {
            HCC: false,
            HCCD: false,
            HCHBP: false,
            HCHC: false,
            HCT: false,
            HCT2D: false,
            lifeExpectancy: '',
          },
          maritalStatus: {
            maritalStatus: 'Single',
            firstName: '',
            lastName: '',
            gender: '',
            lifeExpectancy: '',
            currentIncome: '',
            pia: '',
            PIAYears: {
              includePIA: '',
              startYear: '',
              endYear: '',
              years: [],
            },
          },
          spouses: [
            { maritalStatus: 'Single' }
          ],
          maritalHistory: {
            previousSpouseCount: 0,
            previouslyMarried: false,
            spousePreviouslyMarried: false,
          },
          dependentChildren: {
            children: [],
            hasKids: false,
          }
        }
        this.advisorModal = {
          generalInformation: {
            firstName: '',
            lastName: '',
            title:'',
            address: '',
            city: '',
            state: '',
            zip: '',
            phone: '',
            email: '',
            id: '',
            annualProgramFee: ''
          }
        }

        this.setPageDynamically();

        this.validFormInputs = [
          { isValid: false },
          { isValid: false },
          { isValid: false },
          { isValid: false },
          { isValid: false },
          { isValid: false },
        ];
       
        this.createClientModel = {
          client: {

          },
          clientProfile: {
            HCHBP: false,
            HCHC: false,
            HCT2D: false,
            HCCD: false,
            HCC: false,
            HCT: false,
            clientSpouses: [],
            clientChildren: [],
            PIAYears: {
              IncludePIA: false,
            }
          },
        };

        this.editClientModel = {
          loaded: false,
          client: {

          },
          clientProfile: {
            HCHBP: false,
            HCHC: false,
            HCT2D: false,
            HCCD: false,
            HCC: false,
            HCT: false,
            clientSpouses: [],
            clientChildren: [],
            PIAYears: {
              IncludePIA: false,
            }
          },
        };

        if (this.modalName == 'risk-tolerance') {
          let totalSocialSecurity = 0;
          if (this.isHCIllustration) {
            totalSocialSecurity = modal.data.TotalSocialSecurity;
          }
          this.futureTotalCost = modal.data.FurureTotalCost;
          this.portfolioRecommendationObject = modal.data.PortfolioRecommendationObject;
          this.riskToleranceWhileInstantiate(totalSocialSecurity, this.futureTotalCost, this.portfolioRecommendationObject);
        }

        
        if (this.modalName === 'close-now') {
          return this.close();
        }

        this.getData();
        this.open();
      }
    })
  }

  riskToleranceWhileInstantiate(totalSocialSecurity, furureTotalCost, portfolioRecommendationObject) {

    let date = new Date();
    let dateMonth = date.toLocaleString('en-us', { month: 'short' });
    let dateDay = ("0" + date.getDate()).slice(-2);
    let dateYear = date.getFullYear();
    this.dateTimeNow = date +' ' + dateMonth +','+ dateYear;
    this.clientFirstName = this.modalData.FirstName;
    this.clientLastName = this.modalData.LastName;
    this.spouseFirstName = portfolioRecommendationObject.spouseFirstName;
    this.spouseLastName = portfolioRecommendationObject.spouseLastName;
    this.advisoryFee = this.modalData.AdvisorFee;
    this.isChecked = false;
    this.isNotCandidate = false;
    this.isClientEmailChecked = false;
    this.riskToleranceQuestionnaire = this.fb.group({
      levelOfInvestment: ['', [Validators.required]],
      lengthOfInvestment: ['', [Validators.required]],
      toleranceOfRisk: ['', [Validators.required]],
      isRedeemAccount:['', [Validators.required]],
    });

    this.riskToleranceNames = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['']
    });

    this.riskToleranceAggrement = this.fb.group({
      aggrement: ['', [Validators.required]], 
    });
    this.riskToleranceMail = this.fb.group({
      email: ['', [Validators.required]],
      txtEmailAddress: [''],
      accountType: ['', [Validators.required]],
      jointOwnerFirstName: [portfolioRecommendationObject.spouseFirstName],
      jointOwnerLastName: [portfolioRecommendationObject.spouseLastName],
      jointOwnerEmail: [''],
      aggrement: ['']
    });

      this.estimatedCosts = furureTotalCost;
      this.ssDeductions =  totalSocialSecurity;
      this.remainingUnfunded =  this.estimatedCosts - this.ssDeductions;
      this.isRetired = this.isBothRetired(portfolioRecommendationObject);
      // SMALLA 01/24/22 : New Requirement
      this.phase1Portfolio = this.isRetired && (portfolioRecommendationObject.phase1Portfolio == 'Aggressive' || portfolioRecommendationObject.phase1Portfolio == 'Growth') ? 'Growth & Income': portfolioRecommendationObject.phase1Portfolio;
      this.phase2Portfolio = portfolioRecommendationObject.phase2Portfolio;
      this.rorPhaseOneRate = portfolioRecommendationObject.phase1Val;
      this.rorPhaseTwoRate = portfolioRecommendationObject.phase2Val;
      let isClientRetiringFirst = portfolioRecommendationObject.isMarried ? Number(portfolioRecommendationObject.clientRetirementAge - portfolioRecommendationObject.clientAge) >= Number(portfolioRecommendationObject.spouseRetirementAge - portfolioRecommendationObject.spouseAge) : true;
      let age;
      if (portfolioRecommendationObject.isMarried && !this.isHCIllustration) {
        age = isClientRetiringFirst ? (Math.max(portfolioRecommendationObject.clientAge, portfolioRecommendationObject.clientRetirementAge)  + "/" + Math.max(portfolioRecommendationObject.spouseAge && portfolioRecommendationObject.spouseRetirementAge)):  (Math.max(portfolioRecommendationObject.spouseAge && portfolioRecommendationObject.spouseRetirementAge) + "/" + Math.max(portfolioRecommendationObject.clientAge, portfolioRecommendationObject.clientRetirementAge));
      } else {
        age = Math.max(portfolioRecommendationObject.clientAge, portfolioRecommendationObject.clientRetirementAge);
      }
      if (this.isHCIllustration) {
        this.rorPhaseOneYear = this.isRetired ? "Through Retirement" : "Through " + portfolioRecommendationObject.year + " (Age "+ age + ")"
      } else {
        this.rorPhaseOneYear = this.isRetired ? "Distribution Through Retirement" : "Through " + portfolioRecommendationObject.year + " (Age "+ age + ")"
      }
      this.setRiskTolRates(this.phase1Portfolio);

  }

  isBothRetired(portfolioRecommendationObject) {
    let isRetired = false;
    if (Number(portfolioRecommendationObject.clientRealAge) >= Number(portfolioRecommendationObject.clientRealRetirementAge)) {
      isRetired = true;
    }
    if(portfolioRecommendationObject.spouseAge && portfolioRecommendationObject.spouseRetirementAge) {
      if (Number(portfolioRecommendationObject.spouseAge) >= Number(portfolioRecommendationObject.spouseRetirementAge)) {
        isRetired = isRetired && true;
      } else {
        isRetired = false;
      }
    }
    return isRetired;
  }

  setRiskTolRates(phase) {
    console.log('phase', phase);
    if (phase == "Conservative Income" || phase == "Stable Value")
            {
                this.equitiesLargeCap = 5;
                this.equitiesMidCap = 2;
                this.equitiesSmallCap = 0;
                this.equitiesInternational = 3;
                this.equitiesReturn = 10;
                this.fixedGovBonds = 60;
                this.fixedCorpBonds = 10;
                this.fixedReturn = 70;
                this.cashMoneyMarket = 20;
                this.cashMoneyMarketReturn = 20;
            }
            else if (phase == "Income")
            {
              this.equitiesLargeCap = 10;
              this.equitiesMidCap = 5;
              this.equitiesSmallCap = 0;
              this.equitiesInternational = 5;
              this.equitiesReturn = 20;
              this.fixedGovBonds = 50;
              this.fixedCorpBonds = 25;
              this.fixedReturn = 75;
              this.cashMoneyMarket = 5;
              this.cashMoneyMarketReturn = 5;
            }
            else if (phase == "Growth & Income")
            {
              this.equitiesLargeCap = 20;
              this.equitiesMidCap = 15;
              this.equitiesSmallCap = 10;
              this.equitiesInternational = 15;
              this.equitiesReturn = 60;
              this.fixedGovBonds = 20;
              this.fixedCorpBonds = 18;
              this.fixedReturn = 38;
              this.cashMoneyMarket = 2;
              this.cashMoneyMarketReturn = 2;
            }
            else if (phase == "Growth")
            {
              this.equitiesLargeCap = 22;
              this.equitiesMidCap = 20;
              this.equitiesSmallCap = 18;
              this.equitiesInternational = 20;
              this.equitiesReturn = 80;
              this.fixedGovBonds = 9;
              this.fixedCorpBonds = 10;
              this.fixedReturn = 19;
              this.cashMoneyMarket = 1;
              this.cashMoneyMarketReturn = 1;
            }
            else if (phase == "Income & Growth")
            {
              this.equitiesLargeCap = 15;
              this.equitiesMidCap = 10;
              this.equitiesSmallCap = 5;
              this.equitiesInternational = 10;
              this.equitiesReturn = 40;
              this.fixedGovBonds = 32;
              this.fixedCorpBonds = 25;
              this.fixedReturn = 57;
              this.cashMoneyMarket = 3;
              this.cashMoneyMarketReturn = 3;
            }
            else if (phase == "Aggressive")
            {
              this.equitiesLargeCap = 25;
              this.equitiesMidCap = 23;
              this.equitiesSmallCap = 20;
              this.equitiesInternational = 22;
              this.equitiesReturn = 90;
              this.fixedGovBonds = 4;
              this.fixedCorpBonds = 5;
              this.fixedReturn = 9;
              this.cashMoneyMarket = 1;
              this.cashMoneyMarketReturn = 1;
            }
  }

  getPortfolioRecommendation() {

    let isClientRetiringFirst = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? Number(this.client.clientProfile.RetirementAge - this.client.clientProfile.currentAge) >= Number(this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : true;
    // RiskTolerance = {
    //   AccountType: this.getNumber(this.riskToleranceQuestionnaire.value.accountType),
    //   FinancialObjID: this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective),
    //   LvlOfInvestExpID: this.getNumber(this.riskToleranceQuestionnaire.value.levelOfInvestment),
    //   LngthOfInvestID: this.getNumber(this.riskToleranceQuestionnaire.value.lengthOfInvestment),
    //   ToleranceOfRiskID: this.getNumber(this.riskToleranceQuestionnaire.value.toleranceOfRisk),
    //   NeedRedeemID: this.getNumber(this.riskToleranceQuestionnaire.value.isRedeemAccount),

    //   Email: (this.riskToleranceMail.value.email == '1') ? this.riskToleranceMail.value.txtEmailAddress : (this.client.advisor ? this.client.advisor.Email : ''),

    //   JointOwnerFirstName: (this.riskToleranceNames.value.firstName) ? this.riskToleranceNames.value.firstName : '',
    //   JointOwnerLastName: (this.riskToleranceNames.value.lastName) ? this.riskToleranceNames.value.lastName : '',
    //   JointOwnerEmail: (this.riskToleranceNames.value.email) ? this.riskToleranceNames.value.email : (this.riskToleranceMail.value.email == '1') ? this.riskToleranceMail.value.txtEmailAddress : (this.client.advisor ? this.client.advisor.Email : ''),
    //   HasSignedAdvisoryAgreement: (this.clientModelV2.riskTolerance.hasSignedAgreement) ? this.clientModelV2.riskTolerance.hasSignedAgreement : this.isChecked 

    // }
      var riskTolerance = {
        ClientID: localStorage.getItem('selectedClient'),
        ClientAge: this.portfolioRecommendationObject.clientAge,
        ClientRetirementAge: this.portfolioRecommendationObject.clientRetirementAge,
        estimateLifeTimeCostInFuture: JSON.stringify(this.futureTotalCost),
        unfundedHealthCareCost: JSON.stringify(this.remainingUnfunded),
        AccountType: this.getNumber(this.riskToleranceMail.value.accountType),
        FinancialObjectiveID: this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective),
        LevelOfInvestmentID: this.getNumber(this.riskToleranceQuestionnaire.value.levelOfInvestment),
        LengthOfInvestmentID: this.getNumber(this.riskToleranceQuestionnaire.value.lengthOfInvestment),
        ToleranceOfRiskID: this.getNumber(this.riskToleranceQuestionnaire.value.toleranceOfRisk),
        NeedRedeemID: this.getNumber(this.riskToleranceQuestionnaire.value.isRedeemAccount),
      }
      console.log('riskTolerance',riskTolerance);
      this.globalService.getRiskTolerancePortfolio(riskTolerance).subscribe(
        resp => {
          let clientAge = JSON.stringify(this.calculateAge(this.client.client.DOB));
          this.portfolioRecommendationObject = {
            year: String(isClientRetiringFirst ? this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB) : this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)),
            phase1Portfolio: resp.PhaseOneRecommend,
            phase2Portfolio: resp.PhaseTwoRecommend,
            phase1Val: resp.PhaseOneROR,
            phase2Val: resp.PhaseTwoROR,
            clientAge: clientAge,
            spouseAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? `${this.calculateAge(this.client.clientProfile.Spouses[0].dob)}` : '0' ,
            clientRetirementAge: this.portfolioRecommendationObject.clientRetirementAge,
            spouseRetirementAge: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.client.clientProfile.Spouses[0].retirementAge : '0' ,
            singleInvestment: (resp.SingleInvestment && resp.SingleInvestment != 0) ? Utils.formatToCurrency(resp.SingleInvestment) : this.portfolioRecommendationObject.singleInvestment,
            unfundedAmount: this.futureTotalCost ? String(Utils.formatToCurrency(this.futureTotalCost)): '$0',
            hcReport: this.portfolioRecommendationObject.hcReport,
            user: this.portfolioRecommendationObject.user,
            ltcReport: this.portfolioRecommendationObject.ltcReport
          }
          console.log('this.portfolioRecommendationObject.hcReport 01',this.portfolioRecommendationObject);
          // calculating single investment for HC Report
          if (this.portfolioRecommendationObject.hcReport) {
            this.portfolioRecommendationObject.hcReport.FrmPhase1Rate = this.portfolioRecommendationObject.phase1Val || 0;
            this.portfolioRecommendationObject.hcReport.FrmPhase1Periods = this.getPhaseDiff(1);
            this.portfolioRecommendationObject.hcReport.FrmPhase2Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
            this.portfolioRecommendationObject.hcReport.FrmPhase2Periods = this.getPhaseDiff(2);
            this.portfolioRecommendationObject.hcReport.FrmPhase3Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
            //FrmPhase1Rate: includeSingleInvestment ? (this.portfolioRecommendationObject.phase1Val ? Number(this.portfolioRecommendationObject.phase1Val):0): (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
            //FrmPhase1Periods: this.riskToleranceEnabled ? this.getPhaseDiff(1) : (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
            
            //FrmPhase2Rate: includeSingleInvestment ? (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0): (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
            
            //FrmPhase2Periods: this.riskToleranceEnabled ? this.getPhaseDiff(2) : (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
            //FrmPhase3Rate: includeSingleInvestment ? (this.portfolioRecommendationObject.phase2Val ? Number(this.portfolioRecommendationObject.phase2Val):0):(this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),
            console.log('this.portfolioRecommendationObject.hcReport',this.portfolioRecommendationObject.hcReport);
            this.globalService.getHCDataV2(this.portfolioRecommendationObject.hcReport, this.portfolioRecommendationObject.user)
            .subscribe(
              data => {
                let hcData = data;
                hcData.Illustrations = JSON.parse(hcData.Illustrations);
                console.log('data', data);
                this.portfolioRecommendationObject.singleInvestment = hcData.Illustrations[0] && hcData.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(hcData.Illustrations[0].BeginningBalance.toFixed(0)) : '$0'
                this.portfolioRecommendationObject.unfundedAmount = hcData.TotalProjectedCost;
              },
              error => {
                this.error = <any>error;
              });
          }

          // calculating single investment for LTC Report
          if (this.portfolioRecommendationObject.ltcReport) {
            this.portfolioRecommendationObject.ltcReport.FrmPhase1Rate = this.portfolioRecommendationObject.phase1Val || 0;
            this.portfolioRecommendationObject.ltcReport.FrmPhase1Periods = this.getPhaseDiff(1);
            this.portfolioRecommendationObject.ltcReport.FrmPhase2Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
            this.portfolioRecommendationObject.ltcReport.FrmPhase2Periods = this.getPhaseDiff(2);
            this.portfolioRecommendationObject.ltcReport.FrmPhase3Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
            
            console.log('this.portfolioRecommendationObject.ltcReport',this.portfolioRecommendationObject.ltcReport);
            this.globalService.getLTCData(this.portfolioRecommendationObject.ltcReport, this.portfolioRecommendationObject.user)
            .subscribe(
              data => {
                let ltcData = data;
                console.log('ltcData', ltcData);
               ltcData.depositedToday = Utils.formatToCurrency(ltcData.depositedToday.toFixed(0));
               this.portfolioRecommendationObject.singleInvestment = ltcData.depositedToday;
              },
              error => {
                this.error = <any>error;
              });
          }
          
          
          this.phase1Portfolio = this.isRetired && (this.portfolioRecommendationObject.phase1Portfolio == 'Aggressive' || this.portfolioRecommendationObject.phase1Portfolio == 'Growth') ? 'Growth & Income': this.portfolioRecommendationObject.phase1Portfolio;
          this.phase2Portfolio = this.portfolioRecommendationObject.phase2Portfolio;
          this.rorPhaseOneRate = this.portfolioRecommendationObject.phase1Val;
          this.rorPhaseTwoRate = this.portfolioRecommendationObject.phase2Val;
          this.setRiskTolRates(this.phase1Portfolio);
        },
        error => {
          this.error = <any>error;
        });
  
  }

  getRetirementYear(retirementAge, dob) {
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    return year + diff;
  }

  setPageDynamically() {

    this.firstPage = 0;
    this.secondPage = 1;
    this.thirdPage = 2;
    this.forthPage = 3;
    this.fifthPage = 4;
    this.sixthPage = 5;
    this.seventhPage = 6;
    
   /*  if (JSON.parse(localStorage.getItem('featRiskTolerance'))) {
      this.firstPage = 0; //GeneralInfo
      this.secondPage = 1; //FinancialInfo
      this.thirdPage = 2; // Risk Tolerance
      this.forthPage = 3; //HealthCondition
      this.fifthPage = 4; //Marital
      this.sixthPage = 5; //Dependent
      this.seventhPage = 6;

    } else {
      this.firstPage = 0;
      this.secondPage = 1;
      // this.thirdPage = 2;
      this.forthPage = 2;
      this.fifthPage = 3;
      this.sixthPage = 4;
      this.seventhPage = 5;
    } */
  }

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  onDateChanged(e, model, validationIndex) {

    if (validationIndex === 0) {
      this.clientModelV2.generalInformation.dobStr = e.formatted;
      this.recalcLEV2(this.clientModelV2, 0)
    } else if (validationIndex === 3) {
      this.clientModelV2.maritalStatus.dobStr = e.formatted;
      this.recalcLEV2(this.clientModelV2, 3)
    } else if (validationIndex === 4) {
      model.dobStr = e.formatted;
      this.formerSpouseLE(model, validationIndex);

    } else if (validationIndex === 5) {
      model.dobStr = e.formatted;
      this.formerSpouseLE(model, validationIndex);
    }
  }

formerSpouseLE (model, validationIndex) {
    if (model.gender && model.dobStr) {
      var LEObject;
      LEObject = {
        gender: Number(model.gender),
        age: this.calculateAge(model.dobStr),
        healthConditions: {
          HCC: model.HCC ? 1 : 0,
          HCCD: model.HCCD ? 1 : 0,
          HCHBP: model.HCHBP ? 1 : 0,
          HCHC: model.HCHC ? 1 : 0,
          HCT: model.HCT ? 1 : 0,
          HCT2D: model.HCT2D ? 1 : 0,
        },
      }
      this.globalService.getLE(LEObject)
        .subscribe(
          le => {
            model.lifeExpectancy = le;
            if (validationIndex === 4) {
              this.clientPreviousSpouseMinAge = Math.min(le, LEObject.age);      
              this.clientPreviousSpouseMaxAge = 100 - this.clientPreviousSpouseMinAge + 1;
            }
            if (validationIndex === 5) {
              this.spousePreviousSpouseMinAge = Math.min(le, LEObject.age);      
              this.spousePreviousSpouseMaxAge = 100 - this.spousePreviousSpouseMinAge + 1;
            }
  
          },
          error => this.error = <any>error);
    }

    this.validateFields(validationIndex);

  }

  onAnnDateChanged(e, model, validationIndex) {
    this.clientModelV2.maritalStatus.anniversaryStr = e.formatted;
    this.validateFields(validationIndex);
  }

  canContinue(i, isButton) {
    if (this.isSelectingAdvisor && this.selectedAdvisor && this.selectedOrganization) {
      return true;
    }
    if (this.clientModelV2.generalInformation.retirementAge > this.clientModelV2.healthInformation.lifeExpectancy) {
      // console.log('button disable 01');
      return false;
    }
    if (this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      if (this.clientModelV2.maritalStatus.retirementAge > this.clientModelV2.maritalStatus.lifeExpectancy) {
        return false;
      }
    }
    // console.log('button disable 02');
    // console.log(isButton);
    // console.log(this.validFormInputs[i].isValid);
    if (this.validFormInputs[i - 1]) {
      // console.log(this.validFormInputs[i - 1].isValid);
    }
    isButton = isButton ? this.validFormInputs[i].isValid : this.validFormInputs[i - 1] && this.validFormInputs[i - 1].isValid;
    // console.log(isButton);
    return isButton;//&& i < 5;
  }

  uploadAndSave() {
    if (this.modalData.Data.section === 'marketing-material') {
      this.uploadAndSaveMM();
    } else if (this.modalData.Data.section === 'info-center') {
      this.uploadAndSaveIC();
    }
  }

  uploadAndSaveMM() {
    let file;

    if (this.selectedDocEvent && this.selectedDocEvent.target && this.selectedDocument.category && this.selectedDocument.title) {
      file = this.selectedDocEvent.target.files[0];
      let formData: FormData = new FormData();
      var date = new Date().getTime() / 1000;

      formData.append('uploadFile', file, this.advisor.OrganizationID + '_' + date + '_doc' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
      formData.append('Email', this.advisor.Email);
      formData.append('UserID', this.advisor.ID.toString());
      formData.append('Category', 'marketing-material');

      this.selectedDocument.section = "marketing-material";

      let idx = 0;

      for (var key in this.modalData.Data.arr) {
        if (this.modalData.Data.arr[key].category === this.selectedDocument.category)
          idx = Number(key);
      }

      this.globalService.UploadOrgDoc(formData)
        .subscribe(
          resp => {
            this.selectedDocument.url = "https://web234.hvsfinancial.com/portal-shared/" + resp._body;

            var item = {
              Category: this.selectedDocument.category,
              Description: this.selectedDocument.description,
              Section: this.selectedDocument.section,
              Title: this.selectedDocument.title,
              Url: this.selectedDocument.url
            }
            this.modalData.Data.arr[idx].items.push(item);
            let arr = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.modalData.Data.arr);

            this.globalService.ReplaceMarketingMaterial(arr).subscribe(
              resp => {
                if (resp) {
                  this.selectedDocument = {
                    category: '',
                    description: '',
                    section: '',
                    title: '',
                    url: '',
                  }

                  this.selectedDocEvent.target.value = '';

                  this.close();
                  this.snackBarService.add('Document has been added', 0);
                } else {
                  this.snackBarService.add('An error occurred - please contact support', 1);
                }
              },
              error => this.error = <any>error);
          },
          error => this.error = <any>error);
    }
  }

  uploadAndSaveIC() {
    let file;

    if (this.selectedDocEvent && this.selectedDocEvent.target) {
      file = this.selectedDocEvent.target.files[0];
      let formData: FormData = new FormData();
      var date = new Date().getTime() / 1000;

      formData.append('uploadFile', file, this.advisor.OrganizationID + '_' + date + '_doc' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
      formData.append('Email', this.advisor.Email);
      formData.append('UserID', this.advisor.ID.toString());
      formData.append('Category', 'info-center');

      this.selectedDocument.section = "info-center";

      let idx = 0;

      for (var key in this.modalData.Data.arr) {
        if (this.modalData.Data.arr[key].category === this.selectedDocument.category)
          idx = Number(key);
      }

      this.globalService.UploadOrgDoc(formData)
        .subscribe(
          resp => {
            this.selectedDocument.url = "https://web234.hvsfinancial.com/portal-shared/" + resp._body;

            var item = {
              Category: this.selectedDocument.category,
              Description: this.selectedDocument.description,
              Section: this.selectedDocument.section,
              Title: this.selectedDocument.title,
              Url: this.selectedDocument.url
            }
            this.modalData.Data.arr[idx].items.push(item);
            let arr = Utils.convertMarketingMaterialOrInfoCenterToOldFormat(this.modalData.Data.arr);

            this.globalService.ReplaceInfoCenter(arr).subscribe(
              resp => {
                if (resp) {
                  this.selectedDocument = {
                    category: '',
                    description: '',
                    section: '',
                    title: '',
                    url: '',
                  }

                  this.selectedDocEvent.target.value = '';

                  this.close();

                  this.snackBarService.add('Document has been added', 0);
                } else {
                  this.snackBarService.add('An error occurred - please contact support', 1);
                }
              },
              error => this.error = <any>error);
          },
          error => this.error = <any>error);
    }
  }

  public featRiskTolerance: boolean = false;

  canSave() {
    if (this.clientModelV2.generalInformation.retirementAge > this.clientModelV2.healthInformation.lifeExpectancy) {
      return false;
    }
    if (this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
      if (this.clientModelV2.maritalStatus.retirementAge > this.clientModelV2.maritalStatus.lifeExpectancy) {
        return false;
      }
    }
    if (this.featRiskTolerance) {
      return this.validFormInputs[0].isValid &&
      this.validFormInputs[1].isValid &&
      this.validFormInputs[2].isValid &&
      this.validFormInputs[3].isValid &&
      this.validFormInputs[4].isValid &&
      this.validFormInputs[5].isValid

    } else {
      return this.validFormInputs[0].isValid &&
      this.validFormInputs[1].isValid &&
      this.validFormInputs[2].isValid &&
      this.validFormInputs[3].isValid &&
      this.validFormInputs[4].isValid
    }

  }

  canSaveAdvisor() {
    let isValid = true;
    isValid = isValid && this.advisorModal.generalInformation.firstName && this.advisorModal.generalInformation.lastName && this.advisorModal.generalInformation.phone && this.advisorModal.generalInformation.email && this.validatePhoneNumber(this.advisorModal.generalInformation.phone, false) && this.validateEmail(this.advisorModal.generalInformation.email, true);
    return isValid;

  }

  ngOnInit(): void {
    // localStorage.setItem('featRiskTolerance', 'true');
    // this.riskTolernaceSection = 'riskToleranceQuestionnaire';
    // this.aggrementSrc = 'https://healthwealthhub.hvsfinancial.com/ReportTemplates/Report_AdvisoryAgreementDefault.aspx';
    // this.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));
    // console.log('this.featRiskTolerance', this.featRiskTolerance);
    this.validateAge();

    this.isRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));

    this.createClientModel = {
      client: {

      },
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [
        ],
        clientChildren: [],
        PIAYears: {
          IncludePIA: false,
        }
      },
    };

    this.editClientModel = {
      loaded: false,
      client: {

      },
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [
        ],
        clientChildren: [],
        PIAYears: {
          IncludePIA: false,
        }
      },
    };

  }

  piaStartYearWarning(dob, model, client) {


  }

  validateAllFields() {
    this.validateFields(0);
    this.validateFields(1);
    this.validateFields(2);
    this.validateFields(3);
    this.validateFields(4);
    this.validateFields(5);
  }

  piaEndYearWarning(dob, model, client) {
  }

  setActiveErrorPage() {
    var page = 0;
    for (var i = 0; i < this.validFormInputs.length; i++) {
      if (!this.validFormInputs[i].isValid && page === 0) {
        page = i;
      }
    }

    this.currentAddEditClientScreen = page;
  }

  public organizations: any;
  public advisors: any;

  public selectedOrganization: any;
  public selectedAdvisors: any;
  public selectedAdvisor: any;

  handleOrgSelected(auto) {
    this.selectedAdvisors = [];
    var temp = [];

    temp = this.advisors.sort((a, b) => {
      if (a.c.FirstName.toLowerCase() < b.c.FirstName.toLowerCase()) return -1;
      if (a.c.FirstName.toLowerCase() > b.c.FirstName.toLowerCase()) return 1;
      return 0;
    });

    temp.forEach((advisor) => {
      if (advisor.o.ID == this.selectedOrganization) {
        if (advisor.c.FirstName.length > 0 && advisor.c.LastName.length > 0) {
          if (advisor.c.IsActive) {
            this.selectedAdvisors.push(advisor);
          }
        }
      }
    });

    if (auto) {
      this.selectedAdvisor = this.advisor.ID;
    } else {
      this.selectedAdvisor = 0;
    }
  }

  public isSelectingAdvisor: boolean = false;

  getData(): void {

    if (this.modalName === 'create-advisor') {
      this.globalService.getAdvisorData(this.ID)
        .subscribe(
          advisor => {
            this.advisor = advisor;
            this.mapToAdvisorObject(this.advisor);
          },
          error => this.error = <any>error);
    } else if (this.modalName === 'add-edit-client' || this.modalName === 'risk-tolerance') {
      if (this.modalData.ID > 0) {
        this.isSelectingAdvisor = false;
        this.updateAddEditClientScreen(1);
      } else if ((Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) && !this.modalData.Advisor) {
        this.isSelectingAdvisor = true;
      }


      if (this.modalData.Advisor) {
        this.selectedAdvisor = {};
        this.selectedAdvisor.c = this.modalData.Advisor;
        this.selectedAdvisor.o = this.modalData.Advisor.OrganizationID;
        this.selectedOrganization = this.modalData.Advisor.OrganizationID;
      }
      this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
        .subscribe(
          advisor => {
            this.advisor = advisor;

            if (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) {
              this.globalService.getOrganizationsData()
                .subscribe(
                  organizations => {
                    var temp = [];

                    organizations.forEach((org) => {
                      if (org.Name.length > 0) {
                        org.Name = org.Name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
                        temp.push(org);
                      }

                      if (this.featRiskTolerance) {
                        this.OrgRIAFee = org['RIAFee'];
                        let totalFee = ((this.OrgRIAFee/100) + this.advisoryFee).toFixed(2);
                        this.AssetManagementAgreement = org['AdvisoryAgreement'];
                        this.AssetManagementAgreement = this.AssetManagementAgreement.replace('{{advisor-cost}}', totalFee);
                        this.AssetManagementAgreementChangedDate = new Date(org['AdvisoryAgreementChangeDate']).toLocaleString();
                        this.AssetManagementAdv2DocUrl = org['ADVPart2'];
                      }
                    });

                    if (this.clientModelV2.riskTolerance.hasSignedAgreement && new Date(this.lastClickedSignedAgreement) <= new Date(this.AssetManagementAgreementChangedDate)) {
                      this.clientModelV2.riskTolerance.hasSignedAgreement = false;
                      this.lastClickedSignedAgreement = '';
                    }
                    temp = temp.sort((a, b) => {
                      if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
                      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
                      return 0;
                    });

                    this.organizations = temp;
                  },
                  error => this.error = <any>error);

              this.globalService.getAdvisorsData(1)
                .subscribe(
                  advisors => {
                    this.advisors = advisors;

                    if (this.isSelectingAdvisor) {
                      this.selectedOrganization = advisor.OrganizationID;
                      // // console.log('this.selectedOrganization 01')
                      // // console.log(this.selectedOrganization);
                      this.handleOrgSelected(true);
                    }
                  },
                  error => this.error = <any>error);
            }
          },
          error => this.error = <any>error);
          this.clientData = false;
      this.globalService.getClientData(this.ID, 4)
        .subscribe(
          client => {
            this.client = client;
            console.log('client', client);
            this.clientData = true;
            this.mapToClientObject(client);

            this.validateAllFields();
            if (client.clientProfile)
              this.setActiveErrorPage();
          },
          error => this.error = <any>error);

    } 
    else if (this.modalName === 'edit-organization') {
      this.globalService.getOrganizationData(this.ID)
        .subscribe(
          organization => { this.organization = organization; },
          error => this.error = <any>error);
    } else if (this.modalName === 'view-lead') {
     
    } else if (this.modalName === 'assign-lead') {
      
    } else if (this.modalName === 'edit-profile') {
      this.globalService.getAdvisorData(this.ID)
        .subscribe(
          advisor => {
            this.advisor = advisor;

            this.advisorTemp = {
              FirstName: this.advisor.FirstName,
              LastName: this.advisor.LastName,
              Phone: this.advisor.Phone,
            }
          },
          error => this.error = <any>error);
    }
    
    else if (this.modalName === 'upload-doc') {
      this.categories = this.modalData.Data.categories;
      this.globalService.getAdvisorData(this.ID)
        .subscribe(
          advisor => {
            this.advisor = advisor;

          },
          error => this.error = <any>error);
    }
    else if (this.modalName === 'mmt-projections') {

    } else if (this.modalName === 'contact-support') {
      this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
        .subscribe(
          advisor => {
            this.advisor = advisor;
          },
          error => this.error = <any>error);
    } else if (this.modalName === 'hc-projections') {
      for (var item in this.modalData.Data) {
        
        for (var key in this.modalData.Data[item]) {
          if (key !== 'ExpectedRateReturn' && key !== 'Year') {
            this.modalData.Data[item][key] = this.modalData.Data[item][key];
          } else if (key == 'ExpectedRateReturn') {
            this.modalData.Data[item][key] = Number.parseFloat(this.modalData.Data[item][key]).toFixed(2) + '%';
          }
        }
      }


    } else if (this.modalName === 'ltc-projections') {

    }

  }

  public hcProjectionTotal: any = {};

  handleProducerClientCreation() {

  } 
 
  mapToClientObject(client) {
    if (client.client && client.client.FirstName) {
      // General Information
      this.clientModelV2.generalInformation.firstName = client.client.FirstName;
      this.clientModelV2.generalInformation.lastName = client.client.LastName;
      this.clientModelV2.generalInformation.gender = client.client.GenderID;
      this.clientModelV2.generalInformation.dob = {
        date: {
          year: new Date(client.client.DOB).getFullYear(),
          month: new Date(client.client.DOB).getMonth() + 1,
          day: new Date(client.client.DOB).getDate()
        }
      };

      this.currentYear = new Date().getFullYear();
      this.dateofBirth = new Date(client.client.DOB).getFullYear();
      this.yob = this.dateofBirth + 14;
      this.endOfPIAStartYear = this.currentYear - this.yob + 1;      
      this.endYear1 = this.dateofBirth + 30;
      this.endYear2 = this.dateofBirth + 80;               
      this.endOfPIAEndYear = this.endYear2 - this.endYear1 + 1;  
   
      this.pensionMinYear = this.dateofBirth + 50;
      this.pensionMaxYear = this.dateofBirth + 75;
      this.endOfPensionYear = this.pensionMaxYear + this.pensionMinYear + 1;
     

      this.clientModelV2.generalInformation.dobStr = client.client.DOB;    

      if (this.clientModelV2.generalInformation.dobStr) {
        const convertAge = new Date(this.clientModelV2.generalInformation.dobStr);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365); 
       }  

      this.clientModelV2.generalInformation.address = client.client.Address;
      this.clientModelV2.generalInformation.city = client.client.City;
      this.clientModelV2.generalInformation.state = client.client.State;
      this.clientModelV2.generalInformation.zip = client.client.Zip;
      this.clientModelV2.generalInformation.phone = client.client.Phone;
      this.clientModelV2.generalInformation.email = client.client.Email;
      this.clientModelV2.generalInformation.useNationalAverage = client.clientProfile.UseNationalAverage || 0; // BP -> Add national average flag
      this.clientModelV2.generalInformation.retirementAge = client.clientProfile.RetirementAge;
      this.clientModelV2.generalInformation.retirementState = client.clientProfile.RetirementState;
      // Financial Information
      this.clientModelV2.financialInformation.currentIncome = this.formatCurrencyV2(client.clientProfile.CurrentIncome);
      this.clientModelV2.financialInformation.irr = client.clientProfile.IRR + '%';
      this.clientModelV2.financialInformation.pia = this.formatCurrencyV2(client.clientProfile.PIA || 0);
      this.clientModelV2.financialInformation.PIAYears = JSON.parse(client.clientProfile.PIAYears) || {};
      this.clientModelV2.financialInformation.pensionAmount = this.formatCurrencyV2(client.clientProfile.Pension);
      this.clientModelV2.financialInformation.pensionStartMonth = client.clientProfile.PensionMonths;
      this.clientModelV2.financialInformation.pensionStartYear = client.clientProfile.PensionYears;
      this.clientModelV2.financialInformation.pensionSubEarnings = client.clientProfile.SubstantialEarningYears;
      this.clientModelV2.financialInformation.hasPension = client.clientProfile.IncludePension == 1 ? true : false;

      // Risk Tolerance
      if (client.clientRiskTolerance) {
        this.clientModelV2.riskTolerance.financialObjective = client.clientRiskTolerance.FinancialObjID ? String(client.clientRiskTolerance.FinancialObjID):'';
        this.clientModelV2.riskTolerance.levelOfInvestment = client.clientRiskTolerance.LvlOfInvestExpID ? String(client.clientRiskTolerance.LvlOfInvestExpID):'';
        this.clientModelV2.riskTolerance.lengthOfInvestment = client.clientRiskTolerance.LngthOfInvestID ? String(client.clientRiskTolerance.LngthOfInvestID):'';
        this.clientModelV2.riskTolerance.toleranceOfRisk = client.clientRiskTolerance.ToleranceOfRiskID ? String(client.clientRiskTolerance.ToleranceOfRiskID): '1';
        this.clientModelV2.riskTolerance.isRedeemAccount = client.clientRiskTolerance.NeedRedeemID ? String(client.clientRiskTolerance.NeedRedeemID): '1';
        this.clientModelV2.riskTolerance.hasSignedAgreement = client.clientRiskTolerance.HasSignedAdvisoryAgreement;
        this.clientModelV2.riskTolerance.hasSignedUpForManagedAccount = client.clientRiskTolerance.HasSignedUpForManagedAccount ? true: false;
        // temporary fix date
        // let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        var d = new Date(client.clientRiskTolerance.SignedAdvisoryAgreementDate);
        // d.toLocaleString('en-US', { timeZone: 'America/New_York' });
        // d.setHours(d.getHours() + 1);
        this.lastClickedSignedAgreement = this.clientModelV2.riskTolerance.hasSignedAgreement ? d.toLocaleString() + ' Central Time Zone' : '';
      }

      // Health Conditions
      this.clientModelV2.healthInformation.HCC = client.clientProfile.HCC == 1 ? true : false;
      this.clientModelV2.healthInformation.HCCD = client.clientProfile.HCCD == 1 ? true : false;
      this.clientModelV2.healthInformation.HCHBP = client.clientProfile.HCHBP == 1 ? true : false;
      this.clientModelV2.healthInformation.HCHC = client.clientProfile.HCHC == 1 ? true : false;
      this.clientModelV2.healthInformation.HCT = client.clientProfile.HCT == 1 ? true : false;
      this.clientModelV2.healthInformation.HCT2D = client.clientProfile.HCT2D == 1 ? true : false;
      this.clientModelV2.healthInformation.lifeExpectancy = client.clientProfile.LifeExpectancy;
     
      this.min = Math.min(this.clientModelV2.healthInformation.lifeExpectancy, this.showAge);      
      this.minAge = this.min
      this.maxAge = 100 - this.minAge + 1;    

      this.clientModelV2.spouses = JSON.parse(client.clientProfile.Spouses);

      if (this.clientModelV2.spouses[0] && this.clientModelV2.spouses[0].maritalStatus != "Single") {
        // Marital Status
        this.clientModelV2.maritalStatus.maritalStatus = typeof this.clientModelV2.spouses[0].maritalStatus === 'undefined' || typeof this.clientModelV2.spouses[0] === 'undefined' ? 'Single' : this.clientModelV2.spouses[0].maritalStatus;
        this.clientModelV2.maritalStatus.firstName = this.clientModelV2.spouses[0].firstName;
        this.clientModelV2.maritalStatus.lastName = this.clientModelV2.spouses[0].lastName;
        this.clientModelV2.maritalStatus.gender = this.clientModelV2.spouses[0].gender;
        this.clientModelV2.maritalStatus.lifeExpectancy = this.clientModelV2.spouses[0].LifeExpectancy;
        this.clientModelV2.maritalStatus.currentIncome = Utils.formatToCurrency(this.clientModelV2.spouses[0].currentIncome);
        let maritalAnniversary = this.clientModelV2.spouses[0].anniversary ? {
          date: {
            year: new Date(this.clientModelV2.spouses[0].anniversary).getFullYear(),
            month: new Date(this.clientModelV2.spouses[0].anniversary).getMonth() + 1,
            day: new Date(this.clientModelV2.spouses[0].anniversary).getDate()
          }
        } : {};
      
      // console.log('maritalAnniversary', maritalAnniversary)
      this.clientModelV2.maritalStatus.anniversary = typeof this.clientModelV2.spouses[0].isUserProvidedAnniversary === 'undefined'? maritalAnniversary: (this.clientModelV2.spouses[0].isUserProvidedAnniversary? maritalAnniversary:'');

      this.spouseDateofBirth = new Date(this.clientModelV2.spouses[0].anniversary).getFullYear();
      this.spouseYob = this.spouseDateofBirth + 14;
      this.spouseEndOfPIAStartYear = this.currentYear - this.spouseYob + 1;      
      this.spouseEndYear1 = this.spouseDateofBirth + 30;
      this.spouseEndYear2 = this.spouseDateofBirth + 80;               
      this.spouseEndOfPIAEndYear = this.spouseEndYear2 - this.spouseEndYear1 + 1; 

      this.clientModelV2.maritalStatus.anniversaryStr = this.clientModelV2.spouses[0].anniversary;



        this.clientModelV2.maritalStatus.dob = this.clientModelV2.spouses[0].dob ? {
          date: {
            year: new Date(this.clientModelV2.spouses[0].dob).getFullYear() || 0,
            month: new Date(this.clientModelV2.spouses[0].dob).getMonth() + 1 || 0,
            day: new Date(this.clientModelV2.spouses[0].dob).getDate() || 0
          }
        } : {};

      this.currentYear = new Date().getFullYear();
      this.spouseDateofBirth = new Date(this.clientModelV2.spouses[0].dob).getFullYear();
      this.spouseYob = this.spouseDateofBirth + 14;
      this.spouseEndOfPIAStartYear = this.currentYear - this.spouseYob + 1;      
      this.spouseEndYear1 = this.spouseDateofBirth + 30;
      this.spouseEndYear2 = this.spouseDateofBirth + 80;               
      this.spouseEndOfPIAEndYear = this.spouseEndYear2 - this.spouseEndYear1 + 1; 

      this.spousePensionMinYear = this.spouseDateofBirth + 50;
      this.spousePensionMaxYear = this.spouseDateofBirth + 75;
      this.spouseEndOfPensionYear = this.spousePensionMaxYear + this.spousePensionMinYear + 1;
     
        this.clientModelV2.maritalStatus.dobStr = this.clientModelV2.spouses[0].dob;


        if (this.clientModelV2.maritalStatus.dobStr) {
          const convertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
          const timeDiff = Math.abs(Date.now() - convertAge.getTime());
          this.spouseShowAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);           
         } 

         this.SpouseMin = Math.min(this.clientModelV2.maritalStatus.lifeExpectancy, this.spouseShowAge);      
         this.spouseMinAge = this.SpouseMin
         this.spouseMaxAge = 100 - this.spouseMinAge + 1;  

        this.clientModelV2.maritalStatus.pia = this.clientModelV2.spouses[0].pia ? this.formatCurrencyV2(this.clientModelV2.spouses[0].pia.replace(/,/g, '').replace('$', '')) : this.formatCurrencyV2(0);
        this.clientModelV2.maritalStatus.PIAYears = this.clientModelV2.spouses[0].PIAYears || {};
        this.clientModelV2.maritalStatus.PIAYears.includePIA = this.clientModelV2.maritalStatus.PIAYears.IncludePIA;
        this.clientModelV2.maritalStatus.PIAYears.startYear = this.clientModelV2.maritalStatus.PIAYears.StartYear;
        this.clientModelV2.maritalStatus.PIAYears.endYear = this.clientModelV2.maritalStatus.PIAYears.EndYear;
        this.clientModelV2.maritalStatus.PIAYears.years = this.clientModelV2.maritalStatus.PIAYears.Years;
        this.clientModelV2.maritalStatus.includePension = this.clientModelV2.spouses[0].includePension;
        this.clientModelV2.maritalStatus.pensionAmount = this.formatCurrencyV2(this.clientModelV2.spouses[0].pension || this.clientModelV2.spouses[0].pensionAmount || 0);
        this.clientModelV2.maritalStatus.pensionMonths = this.clientModelV2.spouses[0].pensionMonth;
        this.clientModelV2.maritalStatus.pensionYears = this.clientModelV2.spouses[0].pensionYear;
        this.clientModelV2.maritalStatus.subEarnings = this.clientModelV2.spouses[0].substantialEarningYears;
        this.clientModelV2.maritalStatus.retirementAge = this.clientModelV2.spouses[0].retirementAge;
        this.clientModelV2.maritalStatus.retirementState = this.clientModelV2.spouses[0].state;
        this.clientModelV2.maritalStatus.HCC = this.clientModelV2.spouses[0].HCC == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCCD = this.clientModelV2.spouses[0].HCCD == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCHBP = this.clientModelV2.spouses[0].HCHBP == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCHC = this.clientModelV2.spouses[0].HCHC == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCT = this.clientModelV2.spouses[0].HCT == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCT2D = this.clientModelV2.spouses[0].HCT2D == 1 ? true : false;
      } else {
        this.clientModelV2.maritalStatus.maritalStatus = 'Single';
      }

      if (this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
        // Marital History
        this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
        this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; //this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
        this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

        this.clientModelV2.maritalHistory.spousePreviouslyMarried = false;
        this.clientModelV2.maritalHistory.spousesSpouseCount = 0;
        this.clientModelV2.maritalHistory.spousesSpouse = [];
      } else {
        // Marital History
        this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
        this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; // this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
        this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;
        this.clientModelV2.spouses[0].maritalHistory = this.clientModelV2.spouses[0].maritalHistory || {};
        this.clientModelV2.maritalHistory.spousePreviouslyMarried = this.clientModelV2.spouses[0].maritalHistory.spousePreviouslyMarried || false;
        this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.spouses[0].maritalHistory.spousesSpouseCount || 0;
        this.clientModelV2.maritalHistory.spousesSpouse = this.clientModelV2.spouses[0].spousesSpouse || [];
      }

      if (!client.clientProfile.LifeExpectancy || client.clientProfile.LifeExpectancy == null) {
        if (this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.gender && this.clientModelV2.generalInformation.dobStr) {
          //here
          var leModel = this.clientModelV2.healthInformation;
          leModel.gender = this.clientModelV2.generalInformation.gender;
          leModel.dob = this.clientModelV2.generalInformation.dobStr;
          this.recalcLEV2(this.clientModelV2, 0, true);
        }
      }

      // Dependent Children
      var children = JSON.parse(client.clientProfile.Children) || [];

      this.clientModelV2.dependentChildren.children = children.children || children;
      this.clientModelV2.dependentChildren.hasKids = children.hasKids || children.length > 0;
      this.clientModelV2.dependentChildren.childrenCount = children.childrenCount || children.length;
      this.advisorModal.generalInformation.annualProgramFee = (client.client.ProgramFeePercent && client.client.ProgramFeePercent != 'null') ? client.client.ProgramFeePercent + '%': '';

    }
  }

  mapToAdvisorObject(advisor) {
    if (advisor) {
      this.advisorModal.generalInformation.firstName = advisor.FirstName;
      this.advisorModal.generalInformation.lastName = advisor.LastName;
      if (advisor.Address) {
        this.advisorModal.generalInformation.address = advisor.Address;
      }
      if (advisor.City) {
        this.advisorModal.generalInformation.city = advisor.City;
      }
      if (advisor.State) {
        this.advisorModal.generalInformation.state = advisor.State;
      }
      if (advisor.Zip) {
        this.advisorModal.generalInformation.zip = advisor.Zip;
      }
      this.advisorModal.generalInformation.phone = advisor.Phone;
      this.advisorModal.generalInformation.email = advisor.Email;
      this.advisorModal.id = advisor.ID;
    }
  }

  onMaritalStatusChange(status) {
    if (this.clientData) {
      if (status == 'Divorced') {
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] ? true : false;
      } else {
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;
      }
    }

    // if (status != 'Single' || status != 'Widow') {

    // } else {

    // }
  }

  saveClientV2(client, directToReports, isRiskTolerance, closeModal) {

    var isRTUsed = localStorage.getItem('featRiskTolerance');//JSON.parse(localStorage.getItem('featRiskTolerance'));    

    if (!this.isSelectingAdvisor && this.modalData.ID == 0 && (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2)) {
      this.modalData.AdvisorID = this.selectedAdvisor.c.ID;
      this.modalData.AdvisorOrgID = this.selectedAdvisor.o.ID;
    }

    if (this.canSave() || isRiskTolerance) {
      let annualProgramFee = null;
      if (isRTUsed && this.advisorModal.generalInformation.annualProgramFee) {
        let re = /\%/gi;
        annualProgramFee = this.advisorModal.generalInformation.annualProgramFee.replace(re, "");
      }

      var UserModel = {
        AdvisorID: this.modalData.AdvisorID || this.advisor.ID,
        OrganizationID: this.modalData.AdvisorOrgID || this.advisor.OrganizationID,
        ID: this.client.client ? this.client.client.ID : 0,
        Username: this.clientModelV2.generalInformation.email,
        Email: this.clientModelV2.generalInformation.email,
        FirstName: this.clientModelV2.generalInformation.firstName,
        LastName: this.clientModelV2.generalInformation.lastName,
        Address: this.clientModelV2.generalInformation.address,
        City: this.clientModelV2.generalInformation.city,
        State: this.clientModelV2.generalInformation.state,
        Zip: this.clientModelV2.generalInformation.zip,
        Phone: this.clientModelV2.generalInformation.phone,
        DOB: this.clientModelV2.generalInformation.dobStr,
        GenderID: Number(this.clientModelV2.generalInformation.gender),
        ProgramFeePercent: annualProgramFee ? Number(annualProgramFee): null
      }

      var tempSpouses = [];
      var tempSpouse = {};

      let youngestSpouseAge = 0;
      for (var i = 0; i < this.clientModelV2.spouses.length; i++) {
        if (this.clientModelV2.spouses[i].dobStr) {
          let spouseDOB = new Date(this.clientModelV2.spouses[i].dobStr);
          let timeDiff = Math.abs(Date.now() - spouseDOB.getTime());
          let age = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
          youngestSpouseAge = youngestSpouseAge == 0 ? age : (age < youngestSpouseAge ? age: youngestSpouseAge);
        }
        tempSpouse = {};
        for (var j in this.clientModelV2.spouses[i]) {
          if (j === "HCHBP") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCHC") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCT2D") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCCD") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCC") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "HCT") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j] == true ? 1 : 0;
          } else if (j === "pia") {
            tempSpouse[j] = this.clientModelV2.spouses[i][j].length ? this.clientModelV2.spouses[i][j].replace(/,/g, "").replace("$", "") : 0;
          } else {
            tempSpouse[j] = this.clientModelV2.spouses[i][j];
          }
        }
        tempSpouses.push(tempSpouse);
      }
      var spouses = [];

      if (this.clientModelV2.maritalStatus.maritalStatus != 'Single') {
        let anniversaryForcedDate;
        if (!this.clientModelV2.maritalStatus.anniversaryStr) {
          let spouseDOB = new Date(this.clientModelV2.maritalStatus.dobStr);
   
          let timeDiff = Math.abs(Date.now() - spouseDOB.getTime());
          let age = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
          if (age < youngestSpouseAge) {
            youngestSpouseAge = age;
          }
          let ageDifference;
          if (youngestSpouseAge >= 30) {
            ageDifference = youngestSpouseAge - 30;
          } else {
            ageDifference = youngestSpouseAge - 18;
          }
          anniversaryForcedDate = new Date();
          anniversaryForcedDate = (anniversaryForcedDate.getMonth() + 1).toString().padStart(2, "0") + '/' + (anniversaryForcedDate.getDate()).toString().padStart(2, "0") + '/' + (anniversaryForcedDate.getFullYear() - ageDifference);
        }
        spouses[0] = { PIAYears: {} };
        spouses[0].PIAYears.IncludePIA = this.clientModelV2.maritalStatus.PIAYears.includePIA;
        spouses[0].PIAYears.StartYear = this.clientModelV2.maritalStatus.PIAYears.startYear;
        spouses[0].PIAYears.EndYear = this.clientModelV2.maritalStatus.PIAYears.endYear;
        spouses[0].PIAYears.Years = this.clientModelV2.maritalStatus.PIAYears.years;
        spouses[0].previouslyMarried = this.clientModelV2.maritalHistory.previouslyMarried ? true : false;
        spouses[0].tenyears = this.clientModelV2.maritalHistory.tenyears;
        spouses[0].alive = this.clientModelV2.maritalHistory.alive;
        spouses[0].maritalStatus = this.clientModelV2.maritalStatus.maritalStatus;
        spouses[0].firstName = this.clientModelV2.maritalStatus.firstName;
        spouses[0].lastName = this.clientModelV2.maritalStatus.lastName;
        spouses[0].dob = this.clientModelV2.maritalStatus.dobStr;
        spouses[0].anniversary = this.clientModelV2.maritalStatus.anniversary ? this.clientModelV2.maritalStatus.anniversaryStr : anniversaryForcedDate;
        spouses[0].currentIncome = this.getNumber(this.clientModelV2.maritalStatus.currentIncome);
        spouses[0].pia = this.clientModelV2.maritalStatus.pia.replace(/,/g, "").replace("$", "") || 0;
        spouses[0].gender = this.clientModelV2.maritalStatus.gender;
        spouses[0].LifeExpectancy = this.clientModelV2.maritalStatus.lifeExpectancy;
        spouses[0].retirementAge = this.clientModelV2.maritalStatus.retirementAge;
        spouses[0].state = this.clientModelV2.maritalStatus.retirementState;
        spouses[0].pension = this.clientModelV2.maritalStatus.pensionAmount || 0;
        spouses[0].includePension = this.clientModelV2.maritalStatus.includePension || false;
        spouses[0].pensionYear = this.clientModelV2.maritalStatus.pensionYears;
        spouses[0].pensionMonth = this.clientModelV2.maritalStatus.pensionMonths;
        spouses[0].substantialEarningYears = this.clientModelV2.maritalStatus.subEarnings;
        spouses[0].HCT2D = this.clientModelV2.maritalStatus.HCT2D == true ? 1 : 0;
        spouses[0].HCHBP = this.clientModelV2.maritalStatus.HCHBP == true ? 1 : 0;
        spouses[0].HCC = this.clientModelV2.maritalStatus.HCC == true ? 1 : 0;
        spouses[0].HCHC = this.clientModelV2.maritalStatus.HCHC == true ? 1 : 0;
        spouses[0].HCCD = this.clientModelV2.maritalStatus.HCCD == true ? 1 : 0;
        spouses[0].HCT = this.clientModelV2.maritalStatus.HCT == true ? 1 : 0;
        spouses[0].spousesSpouse = this.clientModelV2.maritalHistory.spousesSpouse || [];
        spouses[0].maritalHistory = this.clientModelV2.maritalHistory || {};
        spouses[0].isUserProvidedAnniversary = this.clientModelV2.maritalStatus.anniversary ? true: false;
      } else {
        spouses[0] = { PIAYears: {} };
        spouses[0].maritalStatus = this.clientModelV2.maritalStatus.maritalStatus;
        spouses[0].pia = '';
        spouses[0].pension = '';
        spouses[0].previouslyMarried = this.clientModelV2.maritalHistory.previouslyMarried ? true : false;
      }

      if (tempSpouses.length > 1) {
        for (var spouse in tempSpouses) {
          if (Number(spouse) > 0) {
            spouses[spouse] = tempSpouses[spouse];
          }
        }
      }

      // BP - Added national average bool

      var ClientProfile = {
        CurrentIncome: this.getNumber(this.clientModelV2.financialInformation.currentIncome),
        IRR: this.getNumber(this.clientModelV2.financialInformation.irr),
        PIA: this.getNumber(this.clientModelV2.financialInformation.pia),
        RetirementAge: Number(this.clientModelV2.generalInformation.retirementAge),
        UseNationalAverage: Number(this.clientModelV2.generalInformation.useNationalAverage || 0) || 0,
        Pension: this.getNumber(this.clientModelV2.financialInformation.pensionAmount),
        PensionMonths: this.getNumber(Number(this.clientModelV2.financialInformation.pensionStartMonth)),
        PensionYears: this.getNumber(Number(this.clientModelV2.financialInformation.pensionStartYear)),
        SubstantialEarningYears: this.getNumber(Number(this.clientModelV2.financialInformation.pensionSubEarnings)),
        RetirementState: this.clientModelV2.generalInformation.retirementState,
        HCHBP: this.clientModelV2.healthInformation.HCHBP ? 1 : 0,
        HCHC: this.clientModelV2.healthInformation.HCHC ? 1 : 0,
        HCT2D: this.clientModelV2.healthInformation.HCT2D ? 1 : 0,
        HCCD: this.clientModelV2.healthInformation.HCCD ? 1 : 0,
        HCC: this.clientModelV2.healthInformation.HCC ? 1 : 0,
        HCT: this.clientModelV2.healthInformation.HCT ? 1 : 0,
        Spouses: JSON.stringify(spouses), //this.client.clientProfile.Spouses, // order them so first is always the one being claimed off of
        Children: this.clientModelV2.dependentChildren.hasKids ? JSON.stringify(this.clientModelV2.dependentChildren.children) : JSON.stringify([]), //this.client.clientProfile.Children,
        IncludePension: this.clientModelV2.financialInformation.hasPension ? 1 : 0,
        LifeExpectancy: Number(this.clientModelV2.healthInformation.lifeExpectancy),
        PIAYears: JSON.stringify(this.clientModelV2.financialInformation.PIAYears),
      }  
      var RiskTolerance = null;
      if(isRTUsed != 'undefined' && this.riskToleranceQuestionnaire){
        if (JSON.parse(localStorage.getItem('featRiskTolerance'))) {
          console.log('this.riskToleranceQuestionnaire', this.riskToleranceQuestionnaire);
          RiskTolerance = {
            AccountType: this.getNumber(this.riskToleranceMail.value.accountType),
            FinancialObjID: this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective),
            LvlOfInvestExpID: this.getNumber(this.riskToleranceQuestionnaire.value.levelOfInvestment),
            LngthOfInvestID: this.getNumber(this.riskToleranceQuestionnaire.value.lengthOfInvestment),
            ToleranceOfRiskID: this.getNumber(this.riskToleranceQuestionnaire.value.toleranceOfRisk),
            NeedRedeemID: this.getNumber(this.riskToleranceQuestionnaire.value.isRedeemAccount),

            Email: (this.riskToleranceMail.value.email == '1') ? this.riskToleranceMail.value.txtEmailAddress : (this.client.advisor ? this.client.advisor.Email : ''),

            JointOwnerFirstName: this.riskToleranceMail.value.jointOwnerFirstName,
            JointOwnerLastName: this.riskToleranceMail.value.jointOwnerLastName,
            JointOwnerEmail: this.riskToleranceMail.value.jointOwnerEmail,

            // JointOwnerFirstName: (this.riskToleranceNames.value.firstName) ? this.riskToleranceNames.value.firstName : '',
            // JointOwnerLastName: (this.riskToleranceNames.value.lastName) ? this.riskToleranceNames.value.lastName : '',
            // JointOwnerEmail: (this.riskToleranceNames.value.email) ? this.riskToleranceNames.value.email : (this.riskToleranceMail.value.email == '1') ? this.riskToleranceMail.value.txtEmailAddress : (this.client.advisor ? this.client.advisor.Email : ''),

            // OtherOwnerJointOwnerFirstName: (this.riskToleranceMail.value.accountType == '2') ? this.riskToleranceMail.value.jointOwnerFirstName : '',
            // OtherOwnerJointOwnerLastName: (this.riskToleranceMail.value.accountType == '2') ? this.riskToleranceMail.value.jointOwnerLastName : '',
            // OtherOwnerJointOwnerEmail: (this.riskToleranceMail.value.accountType == '2') ? this.riskToleranceMail.value.jointOwnerEmail : '',

            //HACK: we should be using the commented out code on the line below; now 'checked' in a huge modal switch
            HasSignedAdvisoryAgreement: (this.clientModelV2.riskTolerance.hasSignedAgreement) ? this.clientModelV2.riskTolerance.hasSignedAgreement : this.isChecked 
            //(!this.riskToleranceAggrement.invalid) ? true : false
          }
        }
      }
      console.log('UserModel', UserModel)
      console.log('riskTolerance', RiskTolerance)
      if (true) { // validate fields again?
        this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
          .subscribe(
            resp => {

              if (resp.type != 0) {

                if (!this.client.clientProfile) {
                  this.globalService.getClientsData()
                    .subscribe(
                      clients => {
                        var client;
                        localStorage.setItem('selectedClient', resp.message);
                        //UserModel.ID = resp.message;
                        this.snackBarService.add('To create a report for ' + UserModel.FirstName + ' ' + UserModel.LastName + ', please click ', 0, 1, 10000);

                      },
                      error => {
                        this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                        this.error = <any>error;

                      });
                } else {
                  if(closeModal){
                    if(isRiskTolerance){
                      this.snackBarService.add('An email has been sent! ', 0);
                    } else {
                      this.snackBarService.add('Client has been updated', 0);
                    }
                  }
                }

                if (directToReports == true) {
                  localStorage.setItem('selectedClient', resp.message);
                  this.router.navigate(['reports/create']);

                  if (this.selectedAdvisor) {
                  }
                }

                if(closeModal){
                  this.close();
                }

              } else {
                this.snackBarService.add('An error occured creating this client.', 1);
                this.close();
              }

            },
            error => {
              this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
              this.error = <any>error;

            });

      } else {
      }
    }else{
      // console.log('cant save...');
    }
  }

  mapToOldObject(client) {
    return {
      client: {
        Address: '',
        Address2: '',
        AdvisorID: '',
        City: '',
        CreatedDate: '',
        DOB: '',
        Email: '',
        FirstName: '',
        GenderID: '',
        ID: '',
        IsActive: '',
        LastName: '',
        ModifiedBy: '',
        ModifiedDate: '',
        OrganizationID: '',
        Phone: '',
        RoleID: '',
        State: '',
        Username: '',
        Zip: '',
      },
      clientProfile: {
        Children: {},
        ClientID: '',
        CurrentIncome: '',
        HCC: '',
        HCCD: '',
        HCHBP: '',
        HCHC: '',
        HCT: '',
        HCT2D: '',
        IRR: '',
        IncludePension: '',
        LifeExpectancy: '',
        MaritalStatus: '',
        PIA: '',
        PIAYears: {},
        Pension: '',
        PensionMonths: '',
        PensionYears: '',
        RetirementAge: '',
        RetirementState: '',
        SpouseID: '',
        Spouses: [],
        SubstantialEarningYears: '',
      },

    }
  }

  ngAfterViewChecked() {
    // this.scrollEl.nativeElement.scrollTop = 0;
  }


  onClick(e): void {
    if (this.container.nativeElement.classList.contains('visible')) {

    }
  }

  open(): void {
    this.container.nativeElement.classList.remove('hidden');
    this.container.nativeElement.classList.add('visible');
    this.scrollEl.nativeElement.scrollTop = 0;
  }

  close(): void {
    this.globalService.displayFAB = true;
    this.container.nativeElement.classList.remove('visible');
    this.container.nativeElement.classList.add('hidden');

    this.selectedDocument = {
      title: '',
      description: '',
      category: '',
      url: '',
    }

    this.selectedDocEvent = {};
    this.selectedDocFilePath = '';

    this.modalData = {};
    // this.modalName = '';

    this.createClientModel = {
      client: {},
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [],
        clientChildren: [],
      },
    };

    this.editClientModel = {
      loaded: false,
      client: {},
      clientProfile: {
        HCHBP: false,
        HCHC: false,
        HCT2D: false,
        HCCD: false,
        HCC: false,
        HCT: false,
        clientSpouses: [],
        clientChildren: [],
      },
    }

    this.validateDefaultDate = false;
    this.validateDefaultDate2 = false;
    this.validateDefaultDate3 = false;

    this.selectedAdvisor = null;
    this.selectedOrganization = null;
    this.isSelectingAdvisor = false;
    this.client = {};

    this.modalService.add(this.modalName + 'Closed');
    this.riskTolernaceSection = 'riskToleranceQuestionnaire';
    localStorage.removeItem('riskTolReportObject');
  }


  createOrganization(organizationName, organizationEmail, organizationPhone, organizationAddress, organizationCity, organizationState, organizationZip) {

    var OrganizationModel = {
      OrgName: organizationName.value,
      Email: organizationEmail.value,
      Phone: organizationPhone.value,
      Address: organizationAddress.value,
      Address2: '',
      City: organizationCity.value,
      State: organizationState.value,
      Zip: organizationZip.value,
      ParentID: 1,
    }

    this.globalService.createOrganization(OrganizationModel)
      .subscribe(
        resp => {
          if (resp.error === 1) {
            this.snackBarService.add(resp.message, 1);
          } else if (resp.error === 0) {
            this.snackBarService.add(resp.message, 0);
            this.close();
          }
        },
        error => this.error = <any>error);
  }

  saveAdvisor(advisor, directToReports) {


      var UserModel = {
        FirstName: advisor.generalInformation.firstName,
        LastName: advisor.generalInformation.lastName,
        Address: advisor.generalInformation.address,
        City: advisor.generalInformation.city,
        State: advisor.generalInformation.state,
        Zip: advisor.generalInformation.zip,
        Email: advisor.generalInformation.email,
        Phone: advisor.generalInformation.phone,
        OrganizationID: Number(localStorage.getItem('orgID')),
        ID: this.ID, //advisor.id
        UserID: this.ID
      }

      // console.log('UserModel');
      // console.log(UserModel);
      this.globalService.createAdvisor(UserModel)
      .subscribe(
        resp => {
          if (resp.type != 0) {
            this.snackBarService.add('Advisor has been updated', 0);
            this.close();
          } else {
            this.snackBarService.add('An error occured updating this advisor.', 1);
          }

          if (directToReports) {
            this.router.navigate(['clients']);
          }
        },
        error => {
          this.snackBarService.add('There was an issue updating this advisor, please try again later.', 1);
          this.error = <any>error;
        });
        
  }

  createAdvisor(advisorFirstName, advisorLastName, advisorDOB, advisorEmail, advisorPhone, advisorAddress, advisorCity, advisorState, advisorZip) {
    var UserModel = {
      ID: 0,
      FirstName: advisorFirstName.value,
      LastName: advisorLastName.value,
      DOB: advisorDOB.value,
      Email: advisorEmail.value,
      Phone: advisorPhone.value,
      Address: advisorAddress.value,
      City: advisorCity.value,
      State: advisorState.value,
      Zip: advisorZip.value,
      RoleID: 3,
    }

    this.globalService.createAdvisor(UserModel)
      .subscribe(
        resp => { },
        error => this.error = <any>error);
  }

  updateClient() {

    var UserModel = {
      ID: this.client.client.ID,
      Username: this.editClientModel.client.Email,
      Email: this.editClientModel.client.Email,
      FirstName: this.editClientModel.client.FirstName,
      LastName: this.editClientModel.client.LastName,
      Address: this.editClientModel.client.Address,
      City: this.editClientModel.client.City,
      State: this.editClientModel.client.State,
      Zip: this.editClientModel.client.Zip,
      Phone: this.editClientModel.client.Phone,
      DOB: this.editClientModel.client.DOB,
      GenderID: this.editClientModel.client.GenderID,
    }

    if (this.editClientModel.clientProfile.Spouses.length) {
      for (var k in this.editClientModel.clientProfile.Spouses) {
        this.editClientModel.clientProfile.Spouses[k].currentIncome = this.getNumber(this.editClientModel.clientProfile.Spouses[k].currentIncome);
        this.editClientModel.clientProfile.Spouses[k].pension = this.getNumber(this.editClientModel.clientProfile.Spouses[k].pension);
      }
    }

    var tempSpouses = [];
    var tempSpouse = {};

    for (var i = 0; i < this.editClientModel.clientProfile.Spouses.length; i++) {
      tempSpouse = {};
      for (var j in this.editClientModel.clientProfile.Spouses[i]) {
        if (j === "HCHBP") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCHC") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT2D") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCCD") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCC") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT") {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j] == true ? 1 : 0;
        } else {
          tempSpouse[j] = this.editClientModel.clientProfile.Spouses[i][j];
        }
      }
      tempSpouses.push(tempSpouse);
    }

    var ClientProfile = {
      CurrentIncome: this.getNumber(this.editClientModel.clientProfile.CurrentIncome),
      IRR: this.getNumber(this.editClientModel.clientProfile.IRR),
      PIA: this.getNumber(this.editClientModel.clientProfile.PIA),
      RetirementAge: this.getNumber(Number(this.editClientModel.clientProfile.RetirementAge)),
      Pension: this.getNumber(this.editClientModel.clientProfile.Pension),
      PensionMonths: this.getNumber(Number(this.editClientModel.clientProfile.PensionMonths)),
      PensionYears: this.getNumber(Number(this.editClientModel.clientProfile.PensionYears)),
      SubstantialEarningYears: this.getNumber(Number(this.editClientModel.clientProfile.SubstantialEarningYears)),
      RetirementState: this.editClientModel.clientProfile.RetirementState,
      HCHBP: this.editClientModel.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.editClientModel.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.editClientModel.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.editClientModel.clientProfile.HCCD ? 1 : 0,
      HCC: this.editClientModel.clientProfile.HCC ? 1 : 0,
      HCT: this.editClientModel.clientProfile.HCT ? 1 : 0,
      Spouses: JSON.stringify(tempSpouses), // order them so first is always the one being claimed off of
      Children: JSON.stringify(this.editClientModel.clientProfile.Children),
      IncludePension: this.editClientModel.clientProfile.IncludePension ? 1 : 0,
      LifeExpectancy: Number(this.editClientModel.clientProfile.LifeExpectancy),
      PIAYears: JSON.stringify(this.editClientModel.clientProfile.PIAYears),
    }

   /*  var RiskTolerance = {
      FinancialObjectiveID: this.getNumber(this.clientModelV2.riskTolerance.financialObjective),
      LevelOfInvestmentID: this.getNumber(this.clientModelV2.riskTolerance.levelOfInvestment),
      LengthOfInvestmentID: this.getNumber(this.clientModelV2.riskTolerance.lengthOfInvestment),
      ToleranceOfRiskID: this.getNumber(this.clientModelV2.riskTolerance.toleranceOfRisk),
      NeedRedeemID: this.getNumber(this.clientModelV2.riskTolerance.isRedeemAccount),
      Email: ''
    } */
    var RiskTolerance = null;
    if(!this.riskToleranceQuestionnaire.invalid){
      //// console.log('got the new risk tolerance');
      RiskTolerance = {
        FinancialObjectiveID: this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective),
        LevelOfInvestmentID: this.getNumber(this.riskToleranceQuestionnaire.value.levelOfInvestment),
        LengthOfInvestmentID: this.getNumber(this.riskToleranceQuestionnaire.value.lengthOfInvestment),
        ToleranceOfRiskID: this.getNumber(this.riskToleranceQuestionnaire.value.toleranceOfRisk),
        NeedRedeemID: this.getNumber(this.riskToleranceQuestionnaire.value.isRedeemAccount),
        Email: (this.riskToleranceMail.value.email == 'clientEmail') ? this.riskToleranceMail.value.txtEmailAddress : this.client.advisor.Email
      }
    }
    
    var validationErrors = this.validateEditClient();

    if (validationErrors) {
      this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
        .subscribe(
          resp => {
            if (resp.type != 0) {
              this.snackBarService.add('Client has been updated', 0);
              this.close();
            } else {
              this.snackBarService.add('An error occured updating this client.', 1);
            }
          },
          error => {
            this.snackBarService.add('There was an issue updating this client, please try again later.', 1);
            this.error = <any>error;
          });
    } else {
      this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    }


  }

  createClient() {
    var UserModel = {
      AdvisorID: this.advisor.ID,
      OrganizationID: this.advisor.OrganizationID,
      Username: this.createClientModel.client.email || " ",
      Email: this.createClientModel.client.email || " ",
      FirstName: this.createClientModel.client.firstName,
      LastName: this.createClientModel.client.lastName,
      Address: this.createClientModel.client.address,
      City: this.createClientModel.client.city,
      State: this.createClientModel.client.state,
      Zip: Number(this.createClientModel.client.zip.toString().substring(0, 5)),
      Phone: this.createClientModel.client.phone,
      DOB: this.createClientModel.client.DOB,
      GenderID: Number(this.createClientModel.client.gender),
    }


    if (this.createClientModel.clientProfile.clientSpouses.length) {
      for (var k in this.createClientModel.clientProfile.clientSpouses) {
        this.createClientModel.clientProfile.clientSpouses[k].currentIncome = this.getNumber(this.createClientModel.clientProfile.clientSpouses[k].currentIncome);
        this.createClientModel.clientProfile.clientSpouses[k].pension = this.getNumber(this.createClientModel.clientProfile.clientSpouses[k].pension);
        this.createClientModel.clientProfile.clientSpouses[k].PIAYears = this.createClientModel.clientProfile.clientSpouses[k].PIAYears;
      }
    }

    var tempSpouses = [];
    var tempSpouse = {};

    for (var i = 0; i < this.createClientModel.clientProfile.clientSpouses.length; i++) {
      tempSpouse = {};
      for (var j in this.createClientModel.clientProfile.clientSpouses[i]) {
        if (j === "HCHBP") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCHC") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT2D") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCCD") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCC") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else if (j === "HCT") {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j] == true ? 1 : 0;
        } else {
          tempSpouse[j] = this.createClientModel.clientProfile.clientSpouses[i][j];
        }
      }

      tempSpouses.push(tempSpouse);
    }

    var ClientProfile = {
      CurrentIncome: this.getNumber(this.createClientModel.clientProfile.currentIncome),
      IRR: this.getNumber(this.createClientModel.clientProfile.IRR),
      PIA: this.getNumber(this.createClientModel.clientProfile.PIA),
      PIAYears: JSON.stringify(this.createClientModel.clientProfile.PIAYears),
      RetirementAge: this.getNumber(Number(this.createClientModel.clientProfile.retirementAge)),
      Pension: this.getNumber(this.createClientModel.clientProfile.pension),
      PensionMonths: this.getNumber(Number(this.createClientModel.clientProfile.pensionMonth)),
      PensionYears: this.getNumber(Number(this.createClientModel.clientProfile.pensionYear)),
      SubstantialEarningYears: this.getNumber(Number(this.createClientModel.clientProfile.substantialEarningYears)),
      RetirementState: this.createClientModel.clientProfile.retirementState,
      HCHBP: this.createClientModel.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.createClientModel.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.createClientModel.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.createClientModel.clientProfile.HCCD ? 1 : 0,
      HCC: this.createClientModel.clientProfile.HCC ? 1 : 0,
      HCT: this.createClientModel.clientProfile.HCT ? 1 : 0,
      Spouses: JSON.stringify(tempSpouses), // order them so first is always the one being claimed off of
      Children: JSON.stringify(this.createClientModel.clientProfile.clientChildren),
      IncludePension: this.createClientModel.clientProfile.includePension ? 1 : 0,
      LifeExpectancy: Number(this.createClientModel.clientProfile.LifeExpectancy),
    }

    var RiskTolerance = {
      FinancialObjectiveID: this.getNumber(this.clientModelV2.riskTolerance.financialObjective),
      LevelOfInvestmentID: this.getNumber(this.clientModelV2.riskTolerance.levelOfInvestment),
      LengthOfInvestmentID: this.getNumber(this.clientModelV2.riskTolerance.lengthOfInvestment),
      ToleranceOfRiskID: this.getNumber(this.clientModelV2.riskTolerance.toleranceOfRisk),
      NeedRedeemID: this.getNumber(this.clientModelV2.riskTolerance.isRedeemAccount)
    }

    var validationErrors = this.validateCreateClient();

    if (validationErrors) {
      this.globalService.createClient(UserModel, ClientProfile, RiskTolerance)
        .subscribe(
          resp => {
            if (resp.type != 0) {
              this.close();
              this.globalService.getClientsData()
                .subscribe(
                  clients => {
                    var client = clients[clients.length - 1].c || clients[clients.length - 1];

                    localStorage.setItem('selectedClient', client.ID);
                    this.snackBarService.add('To create a report for ' + client.FirstName + ' ' + client.LastName + ', please click ', 0, 1, 10000);
                  },
                  error => {
                    this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
                    this.error = <any>error;
                  });
            } else {
              this.snackBarService.add('An error occured creating this client.', 1);
            }

          },
          error => {
            this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
            this.error = <any>error;

          });
    } else {
      this.snackBarService.add('Please make sure all fields are properly filled out', 1);
    }




  }

  removeSpouse(index, from) {

    if (!this.editClientModel.clientProfile.Spouses) {
      this.editClientModel.clientProfile.Spouses = [];
    }

    if (from == 'edit') {
      this.editClientModel.clientProfile.Spouses.splice(index, 1);
    } else if (from == 'create') {
      this.createClientModel.clientProfile.clientSpouses.splice(index, 1);
    }

    if (from == 'marital-history') {
      this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.maritalHistory.previousSpouseCount - 1;
      this.clientModelV2.spouses.splice(index + 1, 1);
    } else if (from == 'spouse-history') {
      this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.maritalHistory.spousesSpouseCount - 1;
      this.clientModelV2.maritalHistory.spousesSpouse.splice(index, 1);
    }

    this.validateAllFields();
  }

  spouseMaritalChange(e, partner) {
  }

  addPartner(from) {
    if (!this.editClientModel.clientProfile.Spouses) {
      this.editClientModel.clientProfile.Spouses = [];
    }

    if (from == 'edit') {
      this.editClientModel.clientProfile.Spouses.push({
        PIAYears: {
          IncludePIA: false,
        },
        tenyears: true,
        alive: true,
      });
    }
    else if (from == 'create') {
      this.createClientModel.clientProfile.clientSpouses.push({
        PIAYears: {
          IncludePIA: false,
        },
        tenyears: true,
        alive: true,
      });
    }
  }

  removeChild(index, from) {
    if (!this.editClientModel.clientProfile.Children) {
      this.editClientModel.clientProfile.Children = [];
    }

    if (from == 'edit')
      this.editClientModel.clientProfile.Children.splice(index, 1);
    else if (from == 'create')
      this.createClientModel.clientProfile.clientChildren.splice(index, 1);
  }

  addDependentChild(from) {
    if (!this.editClientModel.clientProfile.Children) {
      this.editClientModel.clientProfile.Children = [];
    }

    if (from == 'edit') {
      this.editClientModel.clientProfile.Children.push({});
    }
    else if (from == 'create') {
      this.createClientModel.clientProfile.clientChildren.push({});
    }
  }

  convertMartialStatus(status) {
    if (status === "Single") {
      return 0;
    } else if (status === "Married") {
      return 1;
    } else if (status === "Divorced") {
      return 2;
    } else if (status === "Widowed") {
      return 3;
    }
  }

  validateString(val, isRequired) {
    var regex = /^[a-zA-Z][a-zA-Z .,'-]{2,30}$/;
    if (val) {
      if (val.indexOf('-') > 0 && val.indexOf('-') != val.length - 1) {
        return val ? regex.test(val.replace('-')) : !isRequired;
      } else {
        return val ? regex.test(val) : !isRequired;
      }
    }
  }

  validatePhoneNumber(val, isRequired) {
    var numbers = val ? val.match(/\d/g) : '';
    return val ? numbers.length === 10 : !isRequired;
  }

  validateZip(val, isRequired) {
    return true;
  }

  validateCurrency(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  validateEmail(val, isRequired) {
    var regex = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return val ? regex.test(val) : !isRequired;
  }


  validateDate(val, isRequired) {
    var regex = /^([0-9]{1}|[0-9]{2})\/([0-9]{1}|[0-9]{2})\/([0-9]{4})$/;
    return val ? regex.test(val) : !isRequired;
  }

  validateAnnDate(val, isRequired) {
    const regex = /^([0-9]{1}|[0-9]{2})\/([0-9]{1}|[0-9]{2})\/([0-9]{4})$/;
    
    const clientAge = this.calculateAge(this.clientModelV2.generalInformation.dobStr);
    const spouseAge = this.calculateAge(this.clientModelV2.maritalStatus.dobStr);
    const yearsMarried = this.calculateAge(this.clientModelV2.maritalStatus.anniversaryStr);

    return val && (clientAge - yearsMarried >= 18 && spouseAge - yearsMarried >= 18) ? regex.test(val) : !isRequired;
  }

  validatePercent(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  validatePercentDecimal(val, min, max, isRequired) {
    if (val.toString().substring(0,1) === '.')
      val = `0${val}`;

    let re = /\%/gi;
    val = val.replace(re, "");
    val = (val && val != 'null') ? val.toString() : '';
    var numbers = val ? val.match(/\d+(?:\.\d+)?/g).join('') : '';
    return val ? (numbers >= min && numbers <= max) ? true : false : !isRequired;
  }

  validateNumber(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  getNumber(val) {
    val = val ? val.toString() : '';
    val = val.replace('$', '').replace(',', '');
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? numbers : 0
  }

  formatString(model, field) {
    if (model[field])
      model[field] = model[field].charAt(0).toUpperCase() + model[field].slice(1);
  }




  formatNumber(model, field) {
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    model[field] = numbers.join('');
  }

  formatPercent(model, field, e) {
    if (model[field]) {
      model[field] = model[field].toString();
      var numbers = model[field] ? model[field].match(/\d/g) : '';
      if (e.keyCode && (e.keyCode == 8 || e.keyCode == 46))
        numbers.pop();

      model[field] = numbers.join('') + '%';
    }
  }

  formatPercentDecimal(model, page, e) {
    // console.log('model', model);
    // console.log('keycode', e.keyCode);

    let re = /\%/gi;
    let annualProgramFee = model.replace(re, "");
    
    // console.log(annualProgramFee);
    if (model.includes("%")) {
      model.replace("%", "");
    }

    if ((e.keyCode >= 96 && e.keyCode <= 105) || (e.keyCode == 110) || (e.keyCode >= 49 && e.keyCode <= 57) || (e.keyCode == 48) || (e.keyCode == 190)) {
      // console.log('95')
      this.advisorModal.generalInformation.annualProgramFee = annualProgramFee + '%';
    } else {
      // console.log('none')
      this.advisorModal.generalInformation.annualProgramFee = '';
    }
    this.validateFields(page);
  }


  formatCurrency(model, field) {
    if (model[field]) {
      model[field] = model[field].toString();
      var numbers = model[field] ? model[field].match(/\d/g) : '';
      model[field] = '$' + numbers.join('').toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
  }

  formatCurrencyV2(amount) {
    amount = amount.toString().replace(/,/g, "").replace("$", "");
    return Utils.formatToCurrency(amount);
  }

  formatPhoneNumber(model, field) {
    if (model[field]) {
      model[field] = model[field].toString();
      var numbers = model[field] ? model[field].match(/\d/g) : '';
      if (numbers.length < 3) {
        model[field] = "(" + numbers.join('');
      } else if (numbers.length < 4) {
        model[field] = "(" + numbers.join('') + ")";
      } else if (numbers.length < 7) {
        model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, numbers.length);
      } else if (numbers.length >= 7) {
        model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, 6) + "-" + numbers.join('').substring(6, 10);
      }
    }

  }

  validateCreateClient() {
    var result = true;

    result = result && this.validateString(this.createClientModel.client.firstName, true);
    result = result && this.validateString(this.createClientModel.client.lastName, true);

    result = result && this.validateString(this.createClientModel.client.state, false);
    result = result && this.validateZip(this.createClientModel.client.zip, false);
    result = result && this.validatePhoneNumber(this.createClientModel.client.phone, false);
    result = result && this.validateDate(this.createClientModel.client.DOB, true);
    result = result && this.validateNumber(this.createClientModel.client.gender, 1, 3, true);

    result = result && this.validateCurrency(this.createClientModel.clientProfile.currentIncome, 0, 1000000, true);
    result = result && this.validatePercent(this.createClientModel.clientProfile.IRR, 10, 201, true);
    result = result && this.validateCurrency(this.createClientModel.clientProfile.PIA, 0, 5000, true);
    result = result && this.validateNumber(this.createClientModel.clientProfile.retirementAge, 1, 71, true);
    result = result && this.validateCurrency(this.createClientModel.clientProfile.pension, 1, 400000, false);
    result = result && this.validateNumber(this.createClientModel.clientProfile.pensionMonth, 1, 13, false);
    result = result && this.validateNumber(this.createClientModel.clientProfile.pensionYear, 2000, 2061, false);
    result = result && this.validateNumber(this.createClientModel.clientProfile.substantialEarningYears, 0, 31, false);
    result = result && this.validateString(this.createClientModel.clientProfile.retirementState, true);

    for (var k in this.createClientModel.clientProfile.clientSpouses) {
      if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Married') {
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].gender, 1, 3, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, false);
        result = result && this.validateDate(this.createClientModel.clientProfile.clientSpouses[k].dob, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].currentIncome, 0, 1000000, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].retirementAge, 1, 71, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].state, true);
      } else if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Divorced') {
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, false);

        if (this.createClientModel.clientProfile.clientSpouses[k].alive == 'true') {
          result = result && this.validateDate(this.createClientModel.clientProfile.clientSpouses[k].dob, true);
          result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].gender, 1, 3, true);
        }

        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.createClientModel.clientProfile.clientSpouses[k].substantialEarningYears, 1, 400000, false);
      } else if (this.createClientModel.clientProfile.clientSpouses[k].maritalStatus == 'Widowed') {
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].maritalStatus, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].firstName, true);
        result = result && this.validateString(this.createClientModel.clientProfile.clientSpouses[k].lastName, true);
        result = result && this.validateCurrency(this.createClientModel.clientProfile.clientSpouses[k].pia, 0, 10001, true);
      }
    }
    return result;
  }


  validateEditClient() {
    var result = true;

    result = result && this.validateString(this.editClientModel.client.FirstName, true);
    result = result && this.validateString(this.editClientModel.client.LastName, true);
    result = result && this.validateString(this.editClientModel.client.State, false);
    result = result && this.validateZip(this.editClientModel.client.Zip, false);
    result = result && this.validatePhoneNumber(this.editClientModel.client.Phone, false);
    result = result && this.validateDate(this.editClientModel.client.DOB, true);
    result = result && this.validateNumber(this.editClientModel.client.GenderID, 1, 3, true);

    result = result && this.validateCurrency(this.editClientModel.clientProfile.CurrentIncome, 0, 1000000, true);
    result = result && this.validatePercent(this.editClientModel.clientProfile.IRR, 10, 201, true);
    result = result && this.validateCurrency(this.editClientModel.clientProfile.PIA, 0, 5000, true);
    result = result && this.validateNumber(this.editClientModel.clientProfile.RetirementAge, 1, 71, true);
    result = result && this.validateCurrency(this.editClientModel.clientProfile.Pension, 0, 400000, false);
    result = result && this.validateNumber(this.editClientModel.clientProfile.PensionMonth, 1, 13, false);
    result = result && this.validateNumber(this.editClientModel.clientProfile.PensionYear, 2000, 2061, false);
    result = result && this.validateNumber(this.editClientModel.clientProfile.SubstantialEarningYears, 0, 31, false);
    result = result && this.validateString(this.editClientModel.clientProfile.RetirementState, true);
    for (var k in this.editClientModel.clientProfile.Spouses) {
      if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Married') {
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].gender, 1, 3, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pia, 0, 10001, false);
        result = result && this.validateDate(this.editClientModel.clientProfile.Spouses[k].dob, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].currentIncome, 0, 1000000, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].retirementAge, 1, 71, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].state, true);
      } else if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Divorced') {
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pia, 0, 10001, true);

        if (this.editClientModel.clientProfile.Spouses[k].alive == "true") {
          result = result && this.validateDate(this.editClientModel.clientProfile.Spouses[k].dob, true);
          result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].gender, 1, 3, true);
        }

        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pension, 0, 400000, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionYear, 2000, 2061, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].pensionMonth, 1, 13, false);
        result = result && this.validateNumber(this.editClientModel.clientProfile.Spouses[k].substantialEarningYears, 1, 400000, false);
      } else if (this.editClientModel.clientProfile.Spouses[k].maritalStatus == 'Widowed') {
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].maritalStatus, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].firstName, true);
        result = result && this.validateString(this.editClientModel.clientProfile.Spouses[k].lastName, true);
        result = result && this.validateCurrency(this.editClientModel.clientProfile.Spouses[k].pia, 0, 10001, true);
      } else {
        result = false;
      }


    }


    return result;
  }

  formatEditClientModel() {
    this.formatString(this.editClientModel.client, 'firstName');
    this.formatString(this.editClientModel.client, 'lastName');
    this.formatPhoneNumber(this.editClientModel.client, 'phone');

    this.formatCurrency(this.editClientModel.clientProfile, 'CurrentIncome');
    this.formatPercent(this.editClientModel.clientProfile, 'IRR', {});
    this.formatCurrency(this.editClientModel.clientProfile, 'PIA');
    this.formatCurrency(this.editClientModel.clientProfile, 'pension');

    for (var k in this.editClientModel.clientProfile.Spouses) {
      this.formatString(this.editClientModel.clientProfile.Spouses[k], 'firstName');
      this.formatString(this.editClientModel.clientProfile.Spouses[k], 'lastName');
      this.formatCurrency(this.editClientModel.clientProfile.Spouses[k], 'currentIncome');
      this.formatCurrency(this.editClientModel.clientProfile.Spouses[k], 'pension');
      this.formatCurrency(this.editClientModel.clientProfile.Spouses[k], 'pia');

    }
  }

  submitSupportTicket(subject, message) {
    this.snackBarService.add('Thank you for submitting a ticket. A support specialist will be in touch.', 0);
    this.close();
    var SupportModel = {
      AdvisorID: Number(this.advisor.ID),
      OrgID: Number(this.advisor.OrganizationID),
      Subject: subject.value.toString(),
      Message: message.value.toString(),
    }

    this.globalService.createSupportTicket(SupportModel)
      .subscribe(
        data => { },
        error => this.error = <any>error);
  }

  public profileImage = localStorage.getItem('profilePhotoPath') && localStorage.getItem('profilePhotoPath').length > 1 ? 'https://web234.hvsfinancial.com/portal-shared/' + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal-shared/anon_user.png';
  public logoImage = localStorage.getItem('logoPhotoPath') && localStorage.getItem('logoPhotoPath').length > 1 ? 'https://web234.hvsfinancial.com/portal-shared/' + localStorage.getItem('logoPhotoPath') : 'https://web234.hvsfinancial.com/portal-shared/logo.png';
  public userRole = localStorage.getItem('roleId');

  uploadProfilePicture(e) {
    let file: File = e.target.files[0];
    let formData: FormData = new FormData();
    var date = new Date().getTime() / 1000;
    formData.append('uploadFile', file, file.name);
    formData.append('Email', this.advisor.Email);
    formData.append('UserID', this.advisor.ID.toString());
    this.globalService.saveProfileImage(formData)
      .subscribe(
        data => {
          localStorage.setItem('profilePhotoPath', data._body);
          this.profileImage = "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('profilePhotoPath');
        },
        error => this.error = <any>error);

  }

  public advisorTemp: any = {};

  updateAdvisor(advisor) {



    var UserModel = {
      UserID: this.advisor.ID,
      FirstName: advisor.FirstName,
      LastName: advisor.LastName,
      Phone: advisor.Phone,
    }

    var validation = this.validateEditProfile(UserModel);

    if (!validation.status) {
      this.snackBarService.add('Please make sure your ' + validation.message, 1);
    } else {
      this.globalService.updateAdvisor(UserModel)
        .subscribe(
          data => {
            if (data) {
              localStorage.setItem('firstName', UserModel.FirstName);
              localStorage.setItem('lastName', UserModel.LastName);
            }

            this.snackBarService.add('Your profile has been updated.', 0);
            this.close();
          },
          error => {
            this.error = <any>error;
            this.close();
          });
    }
  }
  submitCancellation() {
    this.snackBarService.add('Your cancellation request has been sent to our Support Team. Please allow 1-2 business days for your account to be closed, <br/>after which no additional charges will be issued. You will receive any additional correspondence via email.', 0, 0, 15000);
    
    this.close();

    var SupportModel = {
      AdvisorID: Number(localStorage.getItem('selectedAdvisorID')),
      OrgID: Number(localStorage.getItem('orgID')),
      Subject: "Cancellation Request",
      Message: "User has clicked the Cancel Subscription button in their profile. Please close out this account and stop all charges."
    }

    this.globalService.createSupportTicket(SupportModel)
      .subscribe(
        data => { });
        //,error => this.error = <any>error);
  }
  validateEditProfile(UserModel) {
    var result = { status: true, message: '' };
    if (UserModel.Phone.length < 10) {
      result.message = 'phone number meets this format (xxx) xxx-xxxx.';
      result.status = false;
    } else if (!this.validateString(UserModel.FirstName, true) || !this.validateString(UserModel.LastName, true)) {
      result.message = 'first name or last name contains no numbers.';
      result.status = false;
    }
    return result;
  }

  uploadOrgLogo(e) {
    let file: File = e.target.files[0];
    let formData: FormData = new FormData();
    var date = new Date().getTime() / 1000;
    formData.append('uploadFile', file, this.advisor.OrganizationID + '_' + date + '_logo' + file.name.substring(file.name.lastIndexOf('.'), file.name.length));
    formData.append('Email', this.advisor.Email);
    formData.append('UserID', this.advisor.ID.toString());

    this.globalService.uploadOrgLogo(formData)
      .subscribe(
        data => {
          localStorage.setItem('logoPhotoPath', data._body);
          this.logoImage = "https://web234.hvsfinancial.com/portal-shared/" + localStorage.getItem('logoPhotoPath');
        },
        error => this.error = <any>error);
  }


  formatPIAYearV2(model, isSpouse) {
    var startYear = isSpouse ? model.PIAYears.startYear : model.PIAYears.StartYear;
    var endYear = isSpouse ? model.PIAYears.endYear : model.PIAYears.EndYear;
    var currentAge = isSpouse ? this.calculateAge(this.clientModelV2.maritalStatus.dobStr) : this.calculateAge(this.clientModelV2.generalInformation.dobStr);
    var year = new Date().getFullYear();
    
    if (isSpouse)
      model.PIAYears.years = [];
    else
      model.PIAYears.Years = [];

    if (endYear > startYear) {
      for (var i = 0; i < endYear - startYear + 1; i++) {
        if (isSpouse) {

          model.PIAYears.years.push(
            {
              Year: Number(model.PIAYears.startYear) + i,
              Age: Number(startYear) > year ? Math.abs(endYear - year) + currentAge + i : currentAge - Math.abs(startYear - year) + i,
              ActualEarnings: this.formatCurrencyV2(0),
            }
          );
        } else {
          model.PIAYears.Years.push(
            {
              Year: Number(model.PIAYears.StartYear) + i,
              Age: Number(startYear) > year ? Math.abs(endYear - year) + currentAge + i : currentAge - Math.abs(startYear - year) + i,
              ActualEarnings: this.formatCurrencyV2(0),
            }
          );
        }
      }
    }
  }


  formatPIAYear(model, client) {
    var startYear = client ? model.clientProfile.PIAYears.StartYear.match(/\d/g) : model.PIAYears.StartYear.match(/\d/g);
    var endYear = client ? model.clientProfile.PIAYears.EndYear.match(/\d/g) : model.PIAYears.EndYear.match(/\d/g);
    var year = new Date().getFullYear();

    var currentAge = client ? this.calculateAge(model.client.DOB) : this.calculateAge(model.dob);

    if (client) {
      model.clientProfile.PIAYears.StartYear = startYear.join('').substring(0, 4);
      model.clientProfile.PIAYears.EndYear = endYear.join('').substring(0, 4);

      if (model.clientProfile.PIAYears.StartYear.length === 4 && model.clientProfile.PIAYears.EndYear.length === 4) {
        model.clientProfile.PIAYears.Years = [];
        for (var i = 0; i < model.clientProfile.PIAYears.EndYear - model.clientProfile.PIAYears.StartYear + 1; i++) {
          model.clientProfile.PIAYears.Years.push(
            {
              Year: Number(model.clientProfile.PIAYears.StartYear) + i,
              ActualEarnings: this.formatCurrencyV2(0),
              Age: Number(model.clientProfile.PIAYears.StartYear) > year ? Math.abs(model.clientProfile.PIAYears.StartYear - year) + currentAge + i : currentAge - Math.abs(model.clientProfile.PIAYears.StartYear - year) + i
            }
          );
        }
      }

    } else {
      model.PIAYears.StartYear = startYear.join('').substring(0, 4);
      model.PIAYears.EndYear = endYear.join('').substring(0, 4);

      if (model.PIAYears.StartYear.length === 4 && model.PIAYears.EndYear.length === 4) {
        model.PIAYears.Years = [];
        for (var i = 0; i < model.PIAYears.EndYear - model.PIAYears.StartYear + 1; i++) {
          model.PIAYears.Years.push(
            {
              Year: Number(model.PIAYears.StartYear) + i,
              ActualEarnings: this.formatCurrencyV2(0),
              Age: Number(model.PIAYears.StartYear) > year ? Math.abs(model.PIAYears.StartYear - year) + currentAge + i : currentAge - Math.abs(model.PIAYears.StartYear - year) + i
            }
          );
        }
      }
    }


  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);

    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  calculatePIAV2(model, isSpouse) {
    var PIACalculator = {
      currentAge: Number(this.calculateAge(!isSpouse ? model.generalInformation.dobStr : model.maritalStatus.dobStr)),
      earningYear: this.removePIACurrency(!isSpouse ? model.financialInformation.PIAYears.Years : model.maritalStatus.PIAYears.years)
    }


    this.globalService.getPIA(PIACalculator)
      .subscribe(
        data => {
          if (isSpouse) {
            model.maritalStatus.pia = this.formatCurrencyV2(data);
            model.maritalStatus.PIAYears.years = this.addPIACurrency(model.maritalStatus.PIAYears.years);
            this.validateFields(3);
          } else {
            model.financialInformation.pia = this.formatCurrencyV2(data);
            model.financialInformation.PIAYears.Years = this.addPIACurrency(model.financialInformation.PIAYears.Years);
            this.validateFields(1);
          }

        },
        error => this.error = <any>error);
  }

  calculatePIA(model, client) {
    var PIACalculator = {};

    if (client) {
      PIACalculator = {
        currentAge: Number(this.calculateAge(model.client.DOB)),
        earningYear: this.removePIACurrency(model.clientProfile.PIAYears.Years)
      }
    } else {
      PIACalculator = {
        currentAge: Number(this.calculateAge(model.dob)),
        earningYear: this.removePIACurrency(model.PIAYears.Years)
      }
    }

    this.globalService.getPIA(PIACalculator)
      .subscribe(
        data => {
          if (client) {
            model.clientProfile.PIA = this.formatCurrencyV2(data);
            model.clientProfile.PIAYears.Years = this.addPIACurrency(model.clientProfile.PIAYears.Years);
          } else {
            model.pia = this.formatCurrencyV2(data);
            model.PIAYears.Years = this.addPIACurrency(model.PIAYears.Years);
          }


        },
        error => this.error = <any>error);
  }

  removePIACurrency(years) {
    var temp = [];

    for (var item in years) {
      temp.push(years[item]);
      temp[item].ActualEarnings = Number(temp[item].ActualEarnings.replace(/,/g, "").replace("$", ""));
    }

    return temp;
  }

  addPIACurrency(years) {
    var temp = [];

    for (var item in years) {
      temp.push(years[item]);
      temp[item].ActualEarnings = this.formatCurrencyV2(temp[item].ActualEarnings)
    }

    return temp;
  }

  recalcLEV2(model, index, firstLoad = false) {
    // console.log('button disable 03');
    var LEObject;

    if (index === 0) {
      if (model.generalInformation.dobStr && model.generalInformation.gender) {
        LEObject = {
          gender: Number(model.generalInformation.gender),
          age: this.calculateAge(model.generalInformation.dobStr),
          healthConditions: {
            HCC: model.healthInformation.HCC ? 1 : 0,
            HCCD: model.healthInformation.HCCD ? 1 : 0,
            HCHBP: model.healthInformation.HCHBP ? 1 : 0,
            HCHC: model.healthInformation.HCHC ? 1 : 0,
            HCT: model.healthInformation.HCT ? 1 : 0,
            HCT2D: model.healthInformation.HCT2D ? 1 : 0,
          }
        }
      }
      // console.log('button disable 04');
      // console.log(LEObject);
    } else if (index === 3) {
      if (model.maritalStatus.dobStr && model.maritalStatus.gender) {
        LEObject = {
          gender: Number(model.maritalStatus.gender),
          age: this.calculateAge(model.maritalStatus.dobStr),
          healthConditions: {
            HCC: model.maritalStatus.HCC ? 1 : 0,
            HCCD: model.maritalStatus.HCCD ? 1 : 0,
            HCHBP: model.maritalStatus.HCHBP ? 1 : 0,
            HCHC: model.maritalStatus.HCHC ? 1 : 0,
            HCT: model.maritalStatus.HCT ? 1 : 0,
            HCT2D: model.maritalStatus.HCT2D ? 1 : 0,
          }
        }
      }
    }

    if (LEObject && LEObject.gender && LEObject.age) {
      // console.log('button disable 05');
      this.globalService.getLE(LEObject)
        .subscribe(
          le => {
            if (index === 0) {
              // console.log('button disable 06');
              // console.log(le);
              this.clientModelV2.healthInformation.lifeExpectancy = le;
              this.min = Math.min(le, this.showAge);
              this.minAge = this.min;
              this.maxAge = 100 - this.minAge + 1;
            } else if (index === 3) {
              this.clientModelV2.maritalStatus.lifeExpectancy = le;
              if (this.clientModelV2.maritalStatus.dobStr) {
                const convertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
                const timeDiff = Math.abs(Date.now() - convertAge.getTime());
                this.spouseShowAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);
              } 
      
              this.SpouseMin = Math.min(le, this.spouseShowAge);
              this.spouseMinAge = this.SpouseMin;
              this.spouseMaxAge = 100 - this.spouseMinAge + 1;
            }

            if (this.client.clientProfile && firstLoad) {
              // console.log('button disable 07');
              this.setActiveErrorPage();
            }

          },
          error => { this.error = <any>error; });
    }
    
    this.validateAllFields();
  }

  recalcLE(model, type) {

    if (model.dob) { // hack to check if it's a partner (clients dont have alive property)
      var LEObject;

      if (this.validateDate(model.dob, true) && model.gender) {
        LEObject = {
          gender: Number(model.gender),
          age: this.calculateAge(model.dob),
          healthConditions: {
            HCC: model.HCC ? 1 : 0,
            HCCD: model.HCCD ? 1 : 0,
            HCHBP: model.HCHBP ? 1 : 0,
            HCHC: model.HCHC ? 1 : 0,
            HCT: model.HCT ? 1 : 0,
            HCT2D: model.HCT2D ? 1 : 0,
          },
        }
        this.globalService.getLE(LEObject)
          .subscribe(
            le => {
              if (!type)
                model.LifeExpectancy = le;
              else if (type === 'client')
                this.clientModelV2.healthInformation.lifeExpectancy = le;
            },
            error => this.error = <any>error);
      }
    } else {
      if (model.client && this.validateDate(model.client.DOB, true) && (model.client.GenderID || model.client.gender)) {
        LEObject = {
          gender: model.client.GenderID || model.client.gender,
          age: this.calculateAge(model.client.DOB),
          healthConditions: {
            HCC: model.clientProfile.HCC ? 1 : 0,
            HCCD: model.clientProfile.HCCD ? 1 : 0,
            HCHBP: model.clientProfile.HCHBP ? 1 : 0,
            HCHC: model.clientProfile.HCHC ? 1 : 0,
            HCT: model.clientProfile.HCT ? 1 : 0,
            HCT2D: model.clientProfile.HCT2D ? 1 : 0,
          },
        }

        this.globalService.getLE(LEObject)
          .subscribe(
            le => { model.clientProfile.LifeExpectancy = le },
            error => this.error = <any>error);
      }
    }
  }

  assignLead(leadRelationshipId, advisor) {
    this.globalService.assignLead(leadRelationshipId, advisor.c.ID)
      .subscribe(
        resp => {
          this.snackBarService.add("Lead has been assigned to: " + advisor.c.FirstName + ' ' + advisor.c.LastName, 0);
          this.close();
        },
        error => this.error = <any>error);
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1 / 1 / 1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() : '--';
  }

  handleEsc(e) {
    if (e.keyCode == 27) {
      this.close();
    }
  }

  onDateKeyUp(scenario) {
    if (scenario == 'client') {
      this.clientModelV2.generalInformation.dobStr = this.clientModelV2.generalInformation.dob?this.clientModelV2.generalInformation.dob.formatted:'';
    } else if (scenario == 'dateOfMarriage') {
      this.clientModelV2.maritalStatus.anniversaryStr = this.clientModelV2.maritalStatus.anniversary?this.clientModelV2.maritalStatus.anniversary.formatted:'';
    } else  if (scenario == 'spouse') {
      this.clientModelV2.maritalStatus.dobStr = this.clientModelV2.maritalStatus.dob?this.clientModelV2.maritalStatus.dob.formatted:'';
    }
  }

  openRiskTolernaceModal(section) {
    //is form validated
    if(!this.riskToleranceQuestionnaire.invalid){
      if (section != 'done') {
        this.riskTolernaceSection = section
      }

      // if (section == 'riskToleranceQuestionnaire') {
      //   this.riskTolernaceSection = 'riskToleranceQuestionnaire'
      // }
      // if (section == 'riskToleranceNames') {
      //   this.riskTolernaceSection = 'riskToleranceNames'
      // }
      // if (section == 'riskToleranceAggrement') {
      //   this.riskTolernaceSection = 'riskToleranceAggrement'
      // }
      // if (section == 'riskToleranceEmail') {
      //   this.riskTolernaceSection = 'riskToleranceEmail'
      // }
      if (section == 'done') {
        if (this.riskToleranceQuestionnaire.value.toleranceOfRisk == '1') {
          this.isNotCandidate = true;
        } else {
          this.isNotCandidate = false;
          this.riskTolernaceSection = 'riskToleranceQuestionnaire';
          
          // update the user
          this.saveClientV2(this.clientModelV2, false, true, true);
        }

      }
      this.getPortfolioRecommendation();
    }

  }

  changedClientEmail(evt, scenario) {
    if (scenario == 'clientEmail') {
      this.isClientEmailChecked = evt.target.checked;
      if (this.isClientEmailChecked) {
        this.riskToleranceMail.get("txtEmailAddress").setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')]);
        this.riskToleranceMail.get("txtEmailAddress").updateValueAndValidity();
      }
    } else {
      this.isClientEmailChecked = false;
      this.riskToleranceMail.get("txtEmailAddress").setValidators([]);
      this.riskToleranceMail.get("txtEmailAddress").updateValueAndValidity();
    }

  }

  canContinueRiskTolerance(page) {
    if (page == '2') {
      if (this.isChecked) {
        return true;
      } else {
        return false;
      }
    }

  }

  openADVPart2(){
    window.open(this.AssetManagementAdv2DocUrl, '_blank');
    //window.open('http://healthviewria.com/docs/report/HVAM-PART2A.pdf','_blank');
  }

  openRiskTolerancePDF(createClient: boolean = true) {
    //need to update the users risk tol
    this.saveClientV2(this.clientModelV2, false, true, false);
    if (createClient) {
      this.openRiskTolernaceModal('riskToleranceEmail')
    }

    if (!createClient && this.client && this.client.clientRiskTolerance && this.client.clientRiskTolerance.SignedAdvisoryAgreementDate > this.AssetManagementAgreementChangedDate) {
      this.saveClientV2(this.clientModelV2, false, true, false);
    }
    
    let Values = JSON.parse(localStorage.getItem('riskTolReportObject'));
    //need to modify/add fields to the HCValues now since it does not have the values from the first page (they could have also gone back to change them too before clicking the PDF button)
    //HC = 5 | LTC = 7 //why 7???? because SS is 6
    Values.Report.ReportTypeID = (this.isHCIllustration) ? 5 : 7;

    if(this.isHCIllustration){
      //healthcare
      Values.ReportHC.FrmPhase1Periods = this.getPhaseDiff(1);
      Values.ReportHC.FrmPhase1Rate = this.portfolioRecommendationObject.phase1Val || 0;
      Values.ReportHC.FrmPhase2Periods = this.getPhaseDiff(2);
      Values.ReportHC.FrmPhase2Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
      Values.ReportHC.FrmPhase3Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;

      Values.ReportHC.FinancialObjectiveID = this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective) || 0;
      Values.ReportHC.LevelOfInvestmentID = this.getNumber(this.riskToleranceQuestionnaire.value.levelOfInvestment) || 0;
      Values.ReportHC.LengthOfInvestmentID = this.getNumber(this.riskToleranceQuestionnaire.value.lengthOfInvestment) || 0;
      Values.ReportHC.ToleranceOfRiskID = this.getNumber(this.riskToleranceQuestionnaire.value.toleranceOfRisk) || 0;
      Values.ReportHC.NeedRedeemID = this.getNumber(this.riskToleranceQuestionnaire.value.isRedeemAccount) || 0;

      this.globalService.createReportHC(Values.Report, Values.ReportHC)
      .subscribe(
        resp => {
          this.snackBarService.add("Please wait while your risk tolerance healthcare report is being generated.", 0);
          
          this.downloadReportRiskTolPDF(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
        },
          error => this.error = <any>error);
    } else {
      //long term care
      Values.ReportLTC.FrmPhase1Periods = this.getPhaseDiff(1);
      Values.ReportLTC.FrmPhase1Rate = this.portfolioRecommendationObject.phase1Val || 0;
      Values.ReportLTC.FrmPhase2Periods = this.getPhaseDiff(2);
      Values.ReportLTC.FrmPhase2Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;
      Values.ReportLTC.FrmPhase3Rate = this.isRetired ? this.portfolioRecommendationObject.phase1Val || 0: this.portfolioRecommendationObject.phase2Val || 0;

      Values.ReportLTC.FinancialObjectiveID = this.getNumber(this.riskToleranceQuestionnaire.value.financialObjective) || 0;
      Values.ReportLTC.LevelOfInvestmentID = this.getNumber(this.riskToleranceQuestionnaire.value.levelOfInvestment) || 0;
      Values.ReportLTC.LengthOfInvestmentID = this.getNumber(this.riskToleranceQuestionnaire.value.lengthOfInvestment) || 0;
      Values.ReportLTC.ToleranceOfRiskID = this.getNumber(this.riskToleranceQuestionnaire.value.toleranceOfRisk) || 0;
      Values.ReportLTC.NeedRedeemID = this.getNumber(this.riskToleranceQuestionnaire.value.isRedeemAccount) || 0;

      this.globalService.createReportLTC(Values.Report, Values.ReportLTC)
      .subscribe(
        resp => {
          this.snackBarService.add("Please wait while your risk tolerance long-term care report is being generated.", 0);
          
          this.downloadReportRiskTolPDF(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
        },
          error => this.error = <any>error);
    }
  }

  downloadReportRiskTolPDF(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);
    let spouse = JSON.parse(this.client.clientProfile.Spouses);
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer"), retirementAge: this.client.clientProfile.RetirementAge, spouseRetirementAge: spouse[0].retirementAge || 0 };

    this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  getPhaseDiff(phase) {
    const clientAge = Number(this.calculateAge(this.client.client.DOB));
    const clientRetirementAge = Number(this.client.clientProfile.RetirementAge);
    const clientLE = Number(this.client.clientProfile.LifeExpectancy);
    const spouseAge = Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) || 0;
    const spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge) || 0;
    const spouseLE = Number(this.client.clientProfile.Spouses[0].LifeExpectancy) || 0;
    console.log('getPhaseDiff');
    console.log(
      clientAge,
      clientRetirementAge,
      clientLE,
      spouseAge,
      spouseRetirementAge,
      spouseLE
    );

    if (spouseAge && spouseRetirementAge) {
      if (phase == 1)
        return Math.min(Math.max(0, clientRetirementAge - clientAge), Math.max(0, spouseRetirementAge - spouseAge));
      if (phase == 2)
        return Math.min(Math.max(0, clientLE - clientRetirementAge), Math.max(0, spouseLE - spouseRetirementAge));
    } else {
      if (phase == 1)
        return Math.max(0, clientRetirementAge - clientAge);
      if (phase == 2)
        return Math.max(0, clientLE - clientRetirementAge);
    }
  }

  downloadReport(e, report) {
    
    var reportID = report.reportID;
    var advisorID = report.advisorID;
    var clientID = report.clientID;
    var orgID = report.companyCode;
    var reportTypeID = report.reportTypeID;

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer") };
    this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID)} report`, 0);
    
    this.loadingService.isLoading(true);

    this.globalService.generateReport(ReportFields, report, ReportFields)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error
        this.loadingService.isLoading(false);
      });
  }

  adjustAgreementSignedTime(evt) {
    console.log('this.clientModelV2.riskTolerance.hasSignedAgreement',this.clientModelV2.riskTolerance.hasSignedAgreement)

    if(!this.clientModelV2.riskTolerance.hasSignedAgreement){
      console.log('defined');
      this.isChecked = evt.target.checked;
      if (this.isChecked){
        console.log('defined2');
        this.lastClickedSignedAgreement = new Date().toLocaleString();

      }
   
      this.clientModelV2.riskTolerance.hasSignedAgreement = evt.target.checked;
      console.log('defined3', this.lastClickedSignedAgreement);
      console.log('defined4', this.clientModelV2.riskTolerance.hasSignedAgreement);
    }
   
  }
  canSaveRiskTolerance() {
    let isValid = true;
    if (this.riskToleranceMail.invalid) {
      isValid = false;
    }
    if (this.riskToleranceMail.value.accountType == '2') {
      isValid = isValid && this.validateString(this.riskToleranceMail.value.jointOwnerFirstName, true) && this.validateString(this.riskToleranceMail.value.jointOwnerLastName, true);
      if (this.riskToleranceMail.value.jointOwnerEmail) {
        isValid = isValid && this.validateEmail(this.riskToleranceMail.value.jointOwnerEmail, true);
      }
    }
    if (!this.portfolioRecommendationObject.isMarried && this.riskToleranceMail.value.accountType == '2') {
      isValid = isValid && this.isFinalAgreementChecked
    }
    return isValid;
  }
  adjustFinalAggrement(evt) {
    this.isFinalAgreementChecked = evt.target.checked;
  }

  getRiskTolPhaseAOrAn(phase): string {
    return ['Aggressive','Income & Growth', 'Income'].includes(phase) ? 'an' : 'a'
  }

}
